// 页面顶部搜索
module.exports = {
  // 报表编码
  reportCode: 'reportCode',
  // 报表名称
  reportName: 'reportName',
  // 数据库属性
  databaseProperties: 'databaseProperties',
  // 页面属性
  pageProperties: 'pageProperties',
  // 校验字段
  checkField: 'checkField',
  // 外键
  foreignKey: 'foreignKey',
  // 索引
  index: 'index',
  // 查询配置
  queryConfiguration: 'queryConfiguration',
  // 树表单父ID
  treeFormParentId: 'treeFormParentId',
  // 是否有子节点字段
  IsAChildNodeField: 'IsAChildNodeField',
  // 树开表单列
  treeOpenFormColumn: 'treeOpenFormColumn',
  // 表单编码
  formEncoding: 'formEncoding',
  // 显示复选框
  showCheckbox: 'showCheckbox',
  // 是否分页
  isPaginate: 'isPaginate',
  // 是否树
  isTree: 'isTree',
  // 主题模板
  themeTemplate: 'themeTemplate',
  // 表单风格
  formStyle: 'formStyle',
  // 移动表单风格
  mobileFormStyle: 'mobileFormStyle',
  // 滚动条
  scrollBar: 'scrollBar',
  // 表单分类
  formClassification: 'formClassification',
  // 主键策略
  primaryKeyStrategy: 'primaryKeyStrategy',
  // 使用表单设计
  useFormDesign: 'useFormDesign',
  // 序号名称
  serialNumberName: 'serialNumberName',
  // 一对多
  oneToMany: 'oneToMany',
  // 一对一
  oneOnOne: 'oneOnOne',
  // 单表
  singleTable: '单表',
  // 主表
  primaryTable: '主表',
  // 附表
  schedule: '附表',
  // 请输入类型函数转换
  pleaseEnter: 'Please Enter {field}',
  // 请选择类型函数转换
  pleaseSelect: 'Please Select {field}',
  // 表名
  tableName: 'tableName',
  // 表类型
  tableType: 'tableType',
  // 表描述
  tableDescription: 'tableDescription',
  openMethod: 'openMethod',
  customer: 'customer',
  supplier: 'supplier',
  ThisItemIsRequired: 'This Item Is Required',
  PleaseSelectSynchronizationBusinessType: 'Please Select Synchronization Business Type',
  PleaseSelectModificationStartDate: 'Please Select Modification Start Date',
  PleaseSelectModificationEndDate: 'Please Select Modification End Date',
  head: 'head',
  pleaseEnterHead: 'please Enter Head',
  messageType: 'Message Type',
  notificationType: 'notification Type',
  pleaseChooseNotificationType: 'please Choose Notification Type',
  pleaseChooseMessageType: 'please Choose Message Type',
  publisher: 'publisher',
  designatedUser: 'designated User',
  pleaseChooseDesignatedUser: 'please Choose Designated User',
  allUser: 'all User',
  notice: 'notice',//通知公告
  systemMessage: 'systemMessage',//系统消息
  low: 'low',//低
  middle: 'middle',//中
  high: 'high',//高
  abstract: 'abstract',
  pleaseEnterAbstract: 'please Enter Abstract',
  priority: 'priority',
  content: 'content',
  pleaseChoosePriority: 'please Choose Priority',
  notificationObject: 'notificationObject',
  releaseStatus: 'release Status',
  releaseTime: 'release Time',
  startTime: 'start Time',
  pleaseChooseStartTime: 'please Choose Start Time',
  endTime: 'end Time',
  pleaseChooseEndTime: 'please Choose End Time',
  cancellationTime: 'cancellation Time',
  businessPartners: 'Business partners', // 业务伙伴
  factory: 'Factory', // 工厂
  serialNo: 'Serial No.',//序号
  pleaseEnterSerialNo: 'Please enter serial no',//请输入序号
  periodCode: 'Period Code',//期间代码
  pleaseEnterPeriodCode: 'Please enter period code',//请输入期间代码
  startDate: 'Start Date', // 开始日期
  pleaseSelectStartDate: 'Please select start date',//请选择开始日期
  endDate: 'End Date', // 结束日期
  pleaseSelectEndDate: 'Please select end date',//请选择结束日期
  lockedStatus: 'Locked Status', // 锁定状态
  company: 'Company', // 公司
  pleaseSelectCompany: 'Please select company', // 请选择公司
  periodCode: 'Period Code',//账期
  alreadySelect: 'alreadySelect',//已选
  pleaseSelectPeriod: 'Please select period code',//请选择账期
  pleaseEnterPeriod: 'Please enter period code',//请输入账期
  pleaseSelectType: 'Please select types',//请选择类型
  isProductionCost: 'Production Cost',//是否生产成本
  details: 'Details',//明细
  PeriodCode: 'Period Code',//账期
  pleaseSelectPeriod: 'please select period code',//请选择账期
  serviceDepartmentOrFarm: 'Service Department or Farm', // 服务部或农场
  pleaseSelectServiceDepartmentOrFarm: 'Please select Service Department or Farm', // 请选择服务部或农场
  documentDate: 'Date of document', // 单据日期
  pleaseSelectDocumentDate: 'Please select Document Date', // 请选择单据日期
  documentType: 'Document Type', // 单据类型
  pleaseSelectDocumentType: 'Please select Document Type', // 请选择单据类型
  documentStatus: 'Document Status', // 单据状态
  pleaseSelectDocumentStatus: 'Please select Document Status', // 请选择单据状态
  documentNumber: 'Document Number', // 单据编号
  enterTheDocumentNumberForFuzzyQuery: 'Enter the document No. to fuzzy search', // 输入单据编号模糊查询
  warehouse: 'Warehouse', // 仓库
  pleaseSelectWarehouse: 'Please select Warehouse', // 请选择仓库
  requestFormMode: 'Request form mode', // 申请单模式
  pleaseSelectRequestFormMode: 'Please select Request form mode', // 请选择申请单模式
  sectionAssignmentCategory: 'Section Assignment Category', // 科目分配类别
  pleaseSelectSectionAssignmentCategory: 'Please select Section Assignment Category', // 请选择科目分配类别
  supplierCode: 'Supplier Code', // 供应商编码
  pleaseSelectSupplierCode: 'Please select Supplier Code', // 请选择供应商编码
  supplierName: 'Supplier Name', // 供应商名称
  pleaseEnterSupplierName: 'Please enter the supplier\'s name', // 请输入供应商名称
  demandDate: 'Demand date', // 需求日期
  pleaseSelectTheDemandDate: 'Please select the demand date', // 请选择需求日期
  requestedArrivalDate: 'Requested Arrival Date', // 要求到货日期
  pleaseSelectRequestedArrivalDate: 'Please select Requested Arrival Date', // 请选择要求到货日期
  requisitioner: 'Requisitioner', // 请购员
  pleaseSelectRequisitioner: 'Please select requisitioner', // 请选择请购员
  billingDate: 'Billing Date', // 单据日期
  pleaseSelectTheBillDate: 'Please select the bill date', // 请选择单据账期
  remarks: 'Remarks', // 备注
  pleaseEnterANote: 'Please enter a note', // 请输入备注
  contractCode: 'Contract Code', // 合同编码
  pleaseEnterTheContractCode: 'Please enter the contract code', // 请输入合同编码
  billingStatus: 'Billing Status', // 单据类型
  pleaseSelectBillingStatus: 'Please select Billing Status', // 请选择单据类型
  receiptNumber: 'Receipt Number', // 入库单号
  enterTheIncomingBillNumberToFuzzySearch: 'Enter the incoming bill number to fuzzy search', // 输入入库单号模糊查询
  inboundWarehouse: 'Inbound Warehouse', // 入库仓库
  warehouseLocation: 'Warehouse Location', // 库位
  purchaseContractNumber: 'Purchase Contract Number', // 采购合同号
  pleaseEnterThePurchaseContractNumber: 'Please enter the purchase contract number', // 请输入采购合同号
  postingDate: 'Posting Date', // 过账日期
  pleaseSelectTheDateOfPosting: 'Please select the date of posting', // 请选择过账日期
  licensePlateNumber: 'License plate number', // 车牌号
  pleaseEnterTheLicensePlateNumber: 'Please enter the license plate number', // 请输入车牌号
  orderNumber: 'Order Number', // 订单编号
  pleaseEnterOrderNumber: 'Please enter order Number', // 请输入订单编号
  farm: 'Farm', // 农场
  pleaseSelectFarm: 'Please select farm', // 请选择农场
  transferOutFarm: 'Transfer out farm', // 转出农场
  pleaseSelectTransferOutFarm: 'Please select transfer out farm', // 请选择转出农场
  customerCode: 'Customer Code', // 客户编码
  pleaseSelectTheCustomerCode: 'please select the customer name', // 请选择客户编码
  customerName: 'Customer Name', // 客户名称
  pleaseEnterTheCustomerName: 'Please enter the customer name', // 请输入客户名称
  transferToFarm: 'Transfer to farm', // 转入农场
  pleaseSelectTheFarmToBeTransferredTo: 'Please select the farm to be transferred to', // 请选择转入农场
  requestedDateOfShipment: 'Requested date of shipment', // 要求发货日期
  pleaseSelectTheRequestedDateOfShipment: 'Please select the requested date of shipment', // 请选择要求发货日期
  salesman: 'salesman', // 销售员
  outgoingFarm: 'Outgoing farm', // 出库农场
  pleaseSelectTheOutgoingFarm: 'please select the outgoing farm', // 请选择出库农场
  inboundFarm: 'Inbound Farm', // 入库农场
  building: 'Building', // 栋舍
  pleaseSelectBuilding: 'please select building', // 请选择栋舍
  feedingLot: 'Feeding lot', // 饲养批次
  pleaseEnterTheFeedingLot: 'Please enter the Feeding lot', // 请输入饲养批次
  pleaseSelectTheFeedingLot: 'Please select the Feeding lot', // 请选择饲养批次
  typeOfDeparture: 'Type of departure', // 出库类型
  pleaseSelectTheTypeOfDeparture: 'Please select the type of departure', // 请选择出库类型
  dateOfRelease: 'Date of release', // 出库日期
  pleaseSelectTheDateOfShipment: 'Please select the date of shipment', // 请选择出库日期
  pleaseClickToSelectADepartment: 'Please click to select a department', // 请点击选择部门
  storageType: 'Storage type', // 入库类型
  pleaseSelectTheTypeOfStorage: 'Please select the type of storage', // 请选择入库类型
  dateOfStorage: 'Date of storage', // 入库日期
  pleaseSelectTheDateOfStorage: 'Please select the date of storage', // 请选择入库日期
  transferOutFarmServiceDepartment: 'Transfer out farm/service department', // 转出农场/服务部
  pleaseSelectTransferringFarmService: 'Please select transferring farm/service', // 请选择转出农场/服务部
  transferToFarmService: 'Transfer to Farm/Service', // 转入农场/服务部
  pleaseSelectTheFarmServiceDepartmentToWhichYouAreTransferring: 'Please select the farm/service department to which you are transferring', // 请选择转入农场/服务部
  dateOfTransfer: 'Date of transfer', // 调拨日期
  pleaseSelectTheDateOfTransfer: 'Please select the date of transfer', // 请选择调拨日期
  breed: 'Breed', // 品种
  pleaseEnterTheBreed: 'Please enter the breed', // 请输入品种
  pleaseSelectTheBreed: 'Please select the breed', // 请选择品种
  status: 'Status', // 状态
  pleaseSelectStatus: 'Please select status', // 请选择状态
  batchNumber: 'Batch number', // 批号
  pleaseEnterTheBatchNumber: 'Please enter the batch number', // 请输入批号
  productionBatchNumber: 'Production batch number', // 生产批次编号
  pleaseEnterTheProductionBatchNumber: 'Please enter the production batch number', // 请输入生产批次编号
  theFirstAndLastBitOfTheBatchNumberIsNotAllowedToBeSpace: 'The first and last bit of the batch number is not allowed to be space', // 批次编号首末位不允许为空格
  flockName: 'Flock name', // 批次名称
  pleaseEnterTheFlockName: 'Please enter the flock name', // 请输入批次名称
  settlementBatchNumber: 'Settlement batch number', // 结算批次编号
  pleaseEnterTheSettlementBatchNumber: 'Please enter the settlement batch number', // 请输入结算批次编号
  TheBatchNumberIsLimitedTo8Digits: 'The batch number is limited to 8 digits', // 批次编号限制8位
  placementAge: 'Placement age', // 入舍日龄
  pleaseEnterTheStartingAge: 'Please enter the starting age', // 请输入起始日龄
  category: 'Category', // 品类
  pleaseSelectCategory: 'Please select category', // 请选择品类
  generation: 'Generation', // 代次
  pleaseSelectGeneration: 'Please select generation', // 请选择代次
  breedingType: 'Breeding type', // 养殖类型
  pleaseSelectBreedingType: 'Please select breeding type', // 请选择养殖类型
  startTimeOfVaccination: 'Start time of vaccination', // 防疫开始时间
  pleaseSelectTheStartTimeOfVaccination: 'Please select the start time of vaccination', // 请选择防疫开始时间
  plannedNumberOfHouses: 'Planned number of placement', // 计划入舍数量
  pleaseEnterThePlannedNumberOfHouses: 'Please enter the planned number placement', // 请输入计划入舍数量
  plannedDateOfArrival: 'Scheduled Entry Date', // 计划入舍日期
  pleaseSelectThePlannedArrivalDate: 'Please select the planned date of arrival.', // 请选择计划入舍日期
  plannedTransferDate: 'Planned transfer date', // 计划转场日期
  pleaseSelectThePlanTransferDate: 'Please select the plan transfer date', // 请选择计划转场日期
  planPriceConfirmationDate: 'Plan price confirmation date', // 计划身价确认日期
  pleaseSelectThePlannedPriceConfirmationDate: 'Please select the planned price confirmation (fixing) date', // 请选择计划身价确认（定栏）日期
  plannedCullDate: 'Planned Cull Date', // 计划淘汰日期
  pleaseSelectThePlannedEliminationDate: 'Please select the planned elimination date', // 请选择计划淘汰日期
  breedingMethod: 'Breeding method', // 养殖方式
  pleaseSelectBreedingMethod: 'Please select the breeding method', // 请选择养殖方式
  breeder: 'Breeder', // 饲养员
  pleaseSelectBreeder: 'Please select breeder', // 请选择饲养员
  batchType: 'Batch Type', // 批次类型
  emptyDate: 'Empty date', // 空舍日期
  pleaseSelectTheDateOfEmptying: 'Please select the date of emptying', // 请选择空舍日期
  vaccinationStartDate: 'Vaccination start date', // 防疫开始日期
  pleaseSelectTheStartDateOfVaccination: 'Please select the start date of vaccination', // 请选择防疫开始时间
  DaysOfAge127: '127 days of age', // 127日龄日期
  currentAge: 'Current age', // 当前日龄
  pleaseFillInTheCurrentAge: 'Please fill in the current age', // 请填写当前日龄
  parentBatchNumber: 'Parent Batch Number', // 父级批次编号
  pleaseFillInTheParentBatchNumber: 'Please fill in the parent batch number', // 请填写父级批次编号
  preFeatheringAge: 'Pre-feathering age', // 换羽前日龄
  pleaseFillInTheAgeBeforeFledge: 'Please fill in the age before fledge', // 请填写换羽前日龄
  priceFixingDate: 'Price fixing date', // 身价确定日期
  pleaseSelectTheDateOfPriceDetermination: 'Please select the date of price determination', // 请选择身价确定日期
  priceDeterminationInventory: 'Price Determination Inventory', // 身价确定存栏
  pleaseFillInThePriceDeterminationField: 'Please fill in the price determination field', // 请填写身价确定存栏
  originalValue: 'Original Value', // 身价确定原值
  pleaseFillInThePriceDeterminationOriginalValue: 'Please fill in the price determination original value', // 请填写身价确定原值
  singleSalvageValue: 'Single salvage value', // 单只残值
  pleaseFillInTheSingleSalvageValue: 'Please fill in the single salvage value', // 请填写单只残值
  batchResidualValue: 'Batch residual value', // 批次残值
  pleaseFillInTheLotResidualValue: 'Please fill in the lot residual value', // 请填写批次残值
  batchNetValue: 'Batch net value', // 批次净值
  pleaseFillInTheBatchNetValue: 'Please fill in the batch net value', // 请填写批次净值
  assessedAmount: 'Assessed amount', // 已分摊金额
  pleaseFillInTheApportionedAmount: 'Please fill in the apportioned amount', // 请填写已分摊金额
  deadTransferOut: 'Dead Transfer Out', // 死淘转出
  pleaseFillInTheDeadAmalgamationTransferOut: 'Please fill in the Dead Amalgamation Transfer Out', // 请填写死淘转出
  totalMonthOfApportionment: 'Total Month of Apportionment', // 分摊总月份
  pleaseFillInTheTotalMonthOfApportionment: 'Please fill in the total month of apportionment', // 请填写分摊总月份
  apportionedMonth: 'Apportioned Month', // 已分摊月份
  pleaseFillInTheApportionedMonth: 'Please fill in the apportioned month', // 请填写已分摊月份
  remainingMonths: 'Remaining months', // 剩余分摊月份
  pleaseFillInTheRemainingMonths: 'Please fill in the remaining months', // 请填写剩余分摊月份
  startPeriod: 'Start period', // 开始分摊期间
  pleaseFillInTheStartPeriod: 'Please fill in the start period', // 请填写开始分摊期间
  apportionedPeriod: 'Apportioned period', // 已分摊期间
  pleaseFillInTheApportionedPeriod: 'Please fill in the apportioned period', // 请填写已分摊期间
  nextApportionmentPeriod: 'Next apportionment period', // 下次分摊期间
  pleaseFillInTheNextApportionmentPeriod: 'Please fill in the next apportionment period', // 请填写下次分摊期间
  dateOfAcceptance: 'Date of acceptance', // 验收日期
  pleaseSelectTheDateOfAcceptance: 'Please select the date of acceptance', // 请选择验收日期
  receivingAndInspectionPersonnel: 'Receiving and inspection personnel', // 验收人员
  pleaseSelectTheAcceptancePersonnel: 'Please select the acceptance personnel', // 请选择验收人员
  rejectedItem: 'Rejected item', // 否决项
  pleaseEnterTheVetoItem: 'Please enter the veto item', // 请输入否决项
  judgingCriteria: 'Judging criteria', // 评判标准
  pleaseEnterTheJudgingCriteria: 'Please enter the judging criteria', // 请输入评判标准
  conclusion: 'Conclusion', // 结论
  pleaseSelectConclusion: 'Please select conclusion', // 请选择结论
  synchronizationStatus: 'Synchronization status', // 同步状态
  pleaseSelectTheSynchronizationStatus: 'Please select the synchronization status', // 请选择同步状态
  dayAge: 'Day age', // 日龄
  pleaseEnterTheAgeOfTheDay: 'Please enter the age of the day', // 请输入日龄
  weekAge: 'Week age', // 周龄
  pleaseEnterTheAgeOfTheWeek: 'Please enter the age of the week', // 请输入周龄
  medicine: 'Medicine', // 药品
  pleaseSelectMedicine: 'Please select medicine', // 请选择药品
  materialName: 'Material name', // 物料名称
  pleaseEnterTheNameOfTheMaterial: 'Please enter the name of the material', // 请输入物料名称
  applicableScenario: 'Applicable scenario', // 适用场景
  pleaseSelectTheApplicableScenario: 'Please select the applicable scenario', // 请选择适用场景
  gender: 'Gender', // 性别
  pleaseSelectGender: 'Please select gender', // 请选择性别
  documentInformation: 'Document Information', // 单据信息
  pleaseSelectTheDocumentInformation: 'Please select the document information', // 请选择单据信息
  maximumIndoorTemperature: 'Maximum indoor temperature(℃)', // 最高室内温度(℃)
  pleaseEnterTheHighestIndoorHumidity: 'Please enter the highest indoor humidity', // 请输入最高室内湿度
  lowestIndoorTemperature: 'Lowest indoor temperature(℃)', // 最低室内温度(℃)
  pleaseEnterTheMinimumIndoorTemperature: 'Please enter the minimum indoor temperature', // 请输入最低室内温度
  maximumOutdoorTemperature: 'Maximum outdoor temperature(℃)', // 最高室外温度(℃)
  pleaseInputTheMaximumOutdoorTemperature: 'Please input the maximum outdoor temperature', // 请输入最高室外温度
  lowestOutdoorTemperature: 'Lowest outdoor temperature(℃)', // 最低室外温度(℃)
  pleaseInputTheLowestOutdoorTemperature: 'Please input the lowest outdoor temperature', // 请输入最低室外温度
  maximumBodyTemperature: 'Maximum body temperature(℃)', // 体感最高温度(℃)
  pleaseInputTheMaximumBodyTemperature: 'Please input the maximum body temperature', // 请输入体感最高温度
  minimumTemperature: 'Minimum temperature(℃)', // 体感最低温度(℃)
  pleaseInputTheLowestBodyTemperature: 'Please input the lowest body temperature', // 请输入体感最低温度
  highestIndoorHumidity: 'Highest indoor humidity(%)', // 最高室内湿度(%)
  lowestIndoorHumidity: 'Lowest indoor humidity(%)', // 最低室内湿度(%)
  pleaseEnterTheLowestIndoorHumidity: 'Please enter the lowest indoor humidity', // 请输入最低室内湿度
  maximumOutdoorHumidity: 'Maximum outdoor humidity (%)', // 最高室外湿度(%)
  pleaseEnterTheMaximumOutdoorHumidity: 'Please enter the maximum outdoor humidity', // 请输入最高室外湿度
  minimumOutdoorHumidity: 'Minimum outdoor Humidity(%)', // 最低室外湿度(%)
  pleaseEnterTheMinimumOutdoorHumidity: 'Please enter the minimum outdoor humidity', // 请输入最低室外湿度
  maximumLightIntensity: 'Maximum Light Intensity(Lux)', // 最大光照强度(Lux)
  pleaseEnterTheMaximumLightIntensity: 'Please enter the maximum light intensity', // 请输入最大光照强度
  minimumLightIntensity: 'Minimum light intensity(Lux)', // 最小光照强度(Lux)
  pleaseEnterTheMinimumLightIntensity: 'Please enter the minimum light intensity', // 请输入最小光照强度
  durationOfLight: 'Duration of light(h)', // 光照时长(h)
  pleaseEnterTheDurationOfLight: 'Please enter the duration of light', // 请输入光照时长
  carbonDioxideConcentration: 'Carbon dioxide concentration(%)', // 二氧化碳浓度(%)
  pleaseEnterTheCarbonDioxideConcentration: 'Please enter the carbon dioxide concentration', // 请输入二氧化碳浓度
  maxVentilationCoefficient: 'Max. ventilation coefficient', // 最大通风系数
  pleaseEnterTheMaximumVentilationFactor: 'Please enter the maximum ventilation factor', // 请输入最大通风系数
  minimumVentilationFactor: 'Minimum ventilation factor', // 最小通风系数
  pleaseEnterTheMinimumVentilationFactor: 'Please enter the minimum ventilation factor', // 请输入最小通风系数
  waterConsumption: 'Water consumption (l)', // 耗水量(升)
  pleaseInputWaterConsumption: 'Please input water consumption', // 请输入耗水量
  electricityConsumption: 'Electricity consumption', // 耗电量
  pleaseInputPowerConsumption: 'Please input power consumption', // 请输入耗电量
  fuelType: 'Fuel type', // 燃料类型
  fuelConsumption: 'Fuel consumption', // 燃料消耗量
  pleaseInputFuelConsumption: 'Please input fuel consumption', // 请输入燃料消耗量
  cageUniformity: 'Cage uniformity(%)', // 笼位均匀度(%)
  pleaseInputTheNumberOfCageUniformity: 'Please input the number of cage uniformity', // 请输入笼位均匀数
  maximumIndoorTemperatureMustNotBeLessThanTheMinimumIndoorTemperature: 'Maximum indoor temperature must not be less than the minimum indoor temperature', // 最高室内温度不能小于最低室内温度
  maximumIndoorTemperatureMustBeLessThanTwoDecimalPlaces: 'Maximum indoor temperature must be less than two decimal places', // 最高室内温度必须少于两位小数
  minimumIndoorTemperatureCannotBeGreaterThanTheMaximumIndoorTemperature: 'Minimum indoor temperature cannot be greater than the maximum indoor temperature', // 最低室内温度不能大于最高室内温度
  minimumIndoorTemperatureMustBeLessThanTwoDecimalPlaces: 'Minimum indoor temperature must be less than two decimal places', // 最低室内温度必须少于两位小数
  theMaximumOutdoorTemperatureCannotBeLessThanTheMinimumOutdoorTemperature: 'The maximum outdoor temperature cannot be less than the minimum outdoor temperature', // 最高室外温度不能小于最低室外温度
  theMaximumOutdoorTemperatureMustBeLessThanTwoDecimalPlaces: 'The maximum outdoor temperature must be less than two decimal places', // 最高室外温度必须少于两位小数
  theMinimumOutdoorTemperatureCannotBeGreaterThanTheMaximumOutdoorTemperature: 'The minimum outdoor temperature cannot be greater than the maximum outdoor temperature', // 最低室外温度不能大于最高室外温度
  theMinimumOutdoorTemperatureMustBeLessThanTwoDecimalPlaces: 'The minimum outdoor temperature must be less than two decimal places', // 最低室外温度必须少于两位小数
  theMaximumBodyTemperatureMustNotBeLessThanTheMinimumBodyTemperature: 'The maximum body temperature must not be less than the minimum body temperature', // 最高体感温度不能小于最低体感温度
  theMaximumBodyTemperatureMustBeLessThanTwoDecimalPlaces: 'The maximum body temperature must be less than two decimal places', // 最高体感温度必须少于两位小数
  theMinimumBodyTemperatureMustNotBeGreaterThanTheMaximumBodyTemperature: 'The minimum body temperature must not be greater than the maximum body temperature', // 最低体感温度不能大于最高体感温度
  theMinimumBodyTemperatureMustBeLessThanTwoDecimalPlaces: 'The minimum body temperature must be less than two decimal places', // 最低体感温度必须少于两位小数
  theMaximumIndoorHumidityCannotBeLessThanTheMinimumIndoorHumidity: 'The maximum indoor humidity cannot be less than the minimum indoor humidity', // 最高室内湿度不能小于最低室内湿度
  maximumIndoorHumidityMustBeLessThanTwoDecimalPlaces: 'Maximum indoor humidity must be less than two decimal places', // 最高室内湿度必须少于两位小数
  theMinimumIndoorHumidityCannotBeGreaterThanTheMaximumIndoorHumidity: 'The minimum indoor humidity cannot be greater than the maximum indoor humidity', // 最低室内湿度不能大于最高室内湿度
  minimumIndoorHumidityMustBeLessThanTwoDecimalPlaces: 'Minimum indoor humidity must be less than two decimal places', // 最低室内湿度必须少于两位小数
  theMaximumOutdoorHumidityMustNotBeLessThanTheMinimumOutdoorHumidity: 'The maximum outdoor humidity must not be less than the minimum outdoor humidity', // 最高室外湿度不能小于最低室外湿度
  maximumOutdoorHumidityMustBeLessThanTwoDecimalPlaces: 'Maximum outdoor humidity must be less than two decimal places', // 最高室外湿度必须少于两位小数
  theMinimumOutdoorHumidityCannotBeGreaterThanTheMaximumOutdoorHumidity: 'The minimum outdoor humidity cannot be greater than the maximum outdoor humidity', // 最低室外湿度不能大于最高室外湿度
  minimumOutdoorHumidityMustBeLessThanTwoDecimalPlaces: 'Minimum outdoor humidity must be less than two decimal places', // 最低室外湿度必须少于两位小数
  theMaximumVentilationCoefficientMustNotBeLessThanTheMinimumVentilationCoefficient: 'The maximum ventilation coefficient must not be less than the minimum ventilation coefficient', // 最大通风系数不能小于最小通风系数
  maximumVentilationCoefficientMustBeGreaterThanOrEqualTo: 'Maximum ventilation coefficient must be greater than or equal to 0', // 最大通风系数必须大于等于0
  maximumVentilationCoefficientMustBeLessThanTwoDecimalPlaces: 'Maximum ventilation coefficient must be less than two decimal places', // 最大通风系数必须少于两位小数
  theMinimumVentilationCoefficientCannotBeGreaterThanTheMaximumVentilationCoefficient: 'The minimum ventilation coefficient cannot be greater than the maximum ventilation coefficient', // 最小通风系数不能大于最大通风系数
  minimumVentilationCoefficientMustBeGreaterThanOrEqualTo: 'Minimum ventilation coefficient must be greater than or equal to 0', // 最小通风系数必须大于等于0
  minimumVentilationCoefficientMustBeLessThanTwoDecimalPlaces: 'Minimum ventilation coefficient must be less than two decimal places', // 最小通风系数必须少于两位小数
  waterConsumptionMustBeGreaterThanOrEqualTo: 'Water consumption must be greater than or equal to 0', // 耗水量必须大于等于0
  waterConsumptionMustBeLessThanTwoDecimalPlaces: 'Water consumption must be less than two decimal places', // 耗水量必须少于两位小数
  powerConsumptionMustBeGreaterThanOrEqualTo: 'Power consumption must be greater than or equal to 0', // 耗电量必须大于等于0
  powerConsumptionMustBeLessThanTwoDecimalPlaces: 'Power consumption must be less than two decimal places', // 耗电量必须少于两位小数
  theMaximumLightIntensityMustNotBeLessThanTheMinimumLightIntensity: 'The maximum light intensity must not be less than the minimum light intensity', // 最大光照强度不能小于最小光照强度
  maximumLightIntensityMustBeLessThanTwoDecimalPlaces: 'Maximum light intensity must be less than two decimal places', // 最大光照强度必须少于两位小数
  theMinimumLightIntensityMustNotBeGreaterThanTheMaximumLightIntensity: 'The minimum light intensity must not be greater than the maximum light intensity', // 最小光照强度不能大于最大光照强度
  minimumLightIntensityMustBeLessThanTwoDecimalPlaces: 'Minimum light intensity must be less than two decimal places', // 最小光照强度必须少于两位小数
  theDurationOfLightMustBeGreaterThanOrEqualTo: 'The duration of light must be greater than or equal to 0', // 光照时长必须大于等于0
  theDurationOfLightMustBeLessThanTwoDecimalPlaces: 'The duration of light must be less than two decimal places', // 光照时长必须少于两位小数
  carbonDioxideConcentrationMustBeGreaterThanOrEqualTo: 'Carbon dioxide concentration must be greater than or equal to 0', // 二氧化碳浓度必须大于等于0
  carbonDioxideConcentrationMustBeLessThanTwoDecimalPlaces: 'Carbon dioxide concentration must be less than two decimal places', // 二氧化碳浓度必须少于两位小数
  fuelConsumptionMustBeGreaterThanOrEqualTo: 'Fuel consumption must be greater than or equal to 0', // 燃料消耗量必须大于等于0
  fuelConsumptionMustBeLessThanTwoDecimalPlaces: 'Fuel consumption must be less than two decimal places', // 燃料消耗量必须少于两位小数
  cageUniformityMustBeGreaterThan: 'Cage uniformity must be greater than 0', // 笼位均匀数必须大于0
  cageUniformityMustBeLessThanTwoDecimalPlaces: 'Cage uniformity must be less than two decimal places', // 笼位均匀数必须少于两位小数
  average: 'Average', // 平均值
  pleaseEnterTheAverageValue: 'Please enter the average value', // 请输入平均值
  pleaseAddDetails: 'Please add details', // 请添加明细
  upperLimit: 'Upper limit', // 上限
  lowerLimit: 'Lower limit', // 下限
  uniformity: 'Uniformity(%)', // 均匀度(%)
  submittedBy: 'Submitted by', // 提报人
  pleaseSelectTheSubmitter: 'Please select the submitter!', // 请选择提报人
  testingAge: 'Testing Age', // 检测日龄
  pleaseInputTheTestingAge: 'Please input the testing age', // 请输入检测日龄
  sample: 'Sample', // 样品
  pleaseSelectSample: 'Please select sample', // 请选择样品
  item: 'Item', // 项目
  pleaseSelectTheItem: 'Please select the item', // 请选择项目
  testPerson: 'Test Person', // 检测人员
  pleaseSelectAcceptancePersonnel: 'Please select acceptance personnel', // 请选择检测人员
  testDate: 'Test date', // 检测日期
  pleaseSelectTheDateOfTesting: 'Please select the date of testing', // 请选择检测日期
  coefficientOfVariation: 'Coefficient of variation', // 变异系数
  cullingLoss: 'Culling loss', // 淘汰损失
  totalNumberOfLivestock: 'Total number of livestock', // 畜禽总数量
  numberOfSickHouses: 'Number of sick houses', // 发病舍数量
  deathLoss: 'Death loss', // 死亡损失
  ageAtDiseaseOnset: 'Age at disease onset', // 发病日龄
  productionLoss: 'Production loss', // 生产损失
  dateOfDiseaseOnset: 'Date of disease onset', // 发病日期
  pleaseSelectDateOfOnset: 'Please select date of onset', // 请选择发病日期
  dateOfRecovery: 'Date of recovery', // 痊愈日期
  pleaseSelectTheDateOfRecovery: 'Please select the date of recovery', // 请选择痊愈日期
  testingCost: 'Testing cost', // 检测费用
  numberOfCases: 'Number of cases', // 发病数
  incidenceRate: 'Incidence rate', // 发病率
  treatmentCost: 'Treatment cost', // 治疗费用
  numberOfCulling: 'Number of culling', // 淘汰数
  cullingRate: 'Culling rate', // 淘汰率
  preventionCosts: 'Prevention costs', // 预防费用
  numberOfDeaths: 'Number of deaths', // 死亡数
  mortalityRate: 'Mortality rate', // 死亡率
  otherCosts: 'Other costs', // 其它费用
  productionPerformance: 'Production performance', // 生产性能
  diseaseCategory: 'Disease category', // 疾病类别
  totalLoss: 'Total loss', // 损失合计
  prevalence: 'Prevalence', // 流行情况
  symptoms: 'Symptoms', // 症状
  dissectingLesions: 'Dissecting lesions', // 解刨病变
  detectionItemsAndResults: 'Detection items and results', // 检测项目及结果
  treatmentHistory: 'Treatment history', // 处理经过
  diagnosisResults: 'Diagnosis results', // 诊断结果
  farmCode: 'Farm Code', // 农场编码
  month: 'Month', // 月份
  pleaseSelectTheMonth: 'Please select the month', // 请选择月份
  billMaker: 'Bill maker', // 制单人
  pleaseSelectThePersonWhoInvitesOrderMaking: 'Please select the person who invites order making', // 请选择请制单人
  numberOfPeopleOnTheRegister: 'Number of people on the register', // 在册人数
  pleaseEnterTheNumberOfPeopleOnTheRegister: 'Please enter the number of people on the register', // 请输入在册人数
  theNumberOfRegisteredPersonsMustBeAPositiveInteger: 'The number of registered persons must be a positive integer', // 在册人数必须为正整数
  numberOfOutsideAssociates: 'Number of outside associates', // 外协人数
  pleaseEnterTheNumberOfOutsideAssociates: 'Please enter the number of outside associates',//请输入外协人数
  theNumberOfOutsourcedWorkersMustBeAPositiveInteger: 'The number of outsourced workers must be a positive integer', // 外协人数必须为正整数
  farmerCode: 'Farmer Code', // 养户编码
  pleaseEnterTheFarmerCode: 'Please enter the farmer code', // 请输入养户编码
  farmerName: 'Farmer Name', // 养户名称
  pleaseEnterTheFarmerName: 'Please enter the farmer name', // 请输入养户名称
  farmerType: 'Farmer Type', // 养户类型
  pleaseSelectTheTypeOfFarmer: 'Please select the type of farmer', // 请选择养户类型
  code: 'Code', // 编码
  pleaseEnterTheCode: 'Please enter the code', // 请输入编码
  name: 'Name', // 名称
  pleaseEnterTheName: 'Please enter the name', // 请输入名称
  shortName: 'Short Name', // 简称
  pleaseEnterTheShortName: 'Please enter the short name', // 请输入简称
  fosterFamilyType: 'Foster family type', // 养户类型
  pleaseSelectTheTypeOfFarmer: 'Please select the type of farmer', // 请选择养户类型
  fosterName: 'Foster name', // 养户名称
  pleaseEnterTheNameOfTheAdopter: 'Please enter the name of the adopter', // 请输入养户名称
  taxpayerIdentificationNumber: 'Taxpayer identification number', // 纳税人识别号
  pleaseEnterTheTaxpayerIdentificationNumber: 'Please enter the taxpayer identification number', // 请输入纳税人识别
  idNumber: 'ID number', // 身份证号
  pleaseEnterTheIdCardNumber: 'Please enter the ID card number', // 请输入身份证号
  substituteMaintenanceDepartment: 'Substitute Maintenance Department', // 代养部
  serviceDepartment: 'Service Department', // 服务部
  pleaseSelectTheServiceDepartment: 'Please select the service department', // 请选择服务部
  administrationArea: 'Administration Area', // 行政管理片区
  pleaseEnterTheAdministrativeArea: 'Please enter the administrative area', // 请输入行政管理片区
  technician: 'Technician', // 技术员
  pleaseEnterTechnician: 'Please enter technician', // 请输入技术员
  supervisor: 'Supervisor', // 分管领导
  pleaseEnterTheSupervisor: 'Please enter the supervisor', // 请输入分管领导
  isTheCompany: 'Is the company', // 是否公司
  pleaseSelectWhetherItIsACompany: 'Please select whether it is a company', // 请选择是否公司
  whetherSelfemployedOrNot: 'Whether self-employed or not', // 是否个体户
  yes: 'yes', // 是
  no: 'no', // 否
  pleaseEnterWhetherSelfemployedOrNot: 'Please enter whether you are a self-employed person', // 请输入是否个体户
  longitude: 'Longitude', // 经度
  pleaseEnterTheLongitude: 'Please enter the longitude', // 请输入经度
  latitude: 'Latitude', // 纬度
  pleaseEnterLatitude: 'Please enter latitude', // 请输入纬度
  feedingArea: 'Feeding area', // 喂养面积
  pleaseInputFeedingArea: 'Please input feeding area', // 请输入喂养面积
  breedingScale: 'Breeding scale (only)', // 养殖规模(只）
  pleaseEnterTheBreedingScale: 'Please enter the breeding scale (only)', // 请输入养殖规模(只）
  timeZone: 'Time zone', // 时区
  pleaseInputTimeZone: 'Please input time zone', // 请输入时区
  maximumRadius: 'Maximum radius', // 最大半径
  pleaseEnterTheMaximumRadius: 'Please enter the maximum radius', // 请输入最大半径
  distanceToCompanyKm: 'Distance to company km', // 距离公司公里数
  pleaseEnterTheNumberOfKilometersFromTheCompany: 'Please enter the number of kilometers from the company', // 请输入距离公司公里数
  breederStatus: 'breeder status', // 养户状态
  pleaseSelectTheStatusOfTheBreeder: 'Please select the status of the breeder', // 请选择养户状态
  phoneNumber: 'Phone number', // 电话
  pleaseEnterTelephone: 'Please enter your phone number', // 请输入电话
  cellPhone: 'Cell phone', // 手机
  pleaseEnterYourCellPhone: 'Please enter your cell phone', // 请输入手机
  eMail: 'E-mail', // 邮箱
  pleaseEnterYourEmailAddress: 'Please enter your email address', // 请输入邮箱
  contactPerson: 'Contact person', // 联系人
  pleaseEnterYourContactPerson: 'Please enter your contact person', // 请输入联系人
  weChat: 'WeChat', // 微信
  pleaseInputWechat: 'Please input WeChat', // 请输入微信
  QQ: 'QQ', // QQ
  pleaseEnterQQ: 'Please enter QQ', // 请输入QQ
  spouseName: 'Spouse name', // 配偶姓名
  pleaseEnterYourSpouseName: 'Please enter your spouse name', // 请输入配偶姓名
  spouseCellPhone: 'Spouse cell phone', // 配偶手机
  pleaseEnterYourSpouseCellPhone: 'Please enter your spouse cell phone', // 请输入配偶手机
  spouseIdNumber: 'Spouse ID number', // 配偶身份证号
  pleaseEnterYourSpouseIdNumber: 'Please enter your spouse ID number', // 请输入配偶身份证号
  homeAddress: 'Home Address', // 家庭地址
  pleaseEnterYourHomeAddress: 'Please enter your home address', // 请输入家庭地址
  bankOfAccount: 'Bank of Account', // 开户银行
  pleaseInputTheBankOfAccount: 'Please input the bank of account', // 请输入开户银行
  bankAddress: 'Bank Address',// 开户行地址
  pleaseEnterTheAddressOfYourBank: 'Please enter the address of your bank', // 请输入开户行地址
  accountNumber: 'Account number', // 账号
  pleaseEnterTheAccountNumber: 'Please enter the account number', // 请输入账号
  accountName: 'Account name (account holder)', // 账户名（户主）
  pleaseEnterTheAccountName: 'Please enter the account name (account holder)', // 请输入账户名（户主）
  accessDate: 'Access date', // 准入日期
  pleaseSelectTheAccessDate: 'Please select the access date', // 请选择准入日期
  expirationDate: 'Expiration date', // 失效日期
  pleaseSelectExpirationDate: 'Please select expiration date', // 请选择失效日期
  affiliatedSupplier: 'Affiliated Supplier', // 关联供应商
  affiliatedCustomer: 'Affiliated Customer', // 关联客户
  country: 'Country', // 国家
  pleaseSelectTheCountry: 'Please select the country', // 请选择国家
  province: 'Province', // 省份
  pleaseSelectTheProvince: 'Please select the province', // 请选择省份
  cityPrefectureLevelCity: 'City/prefecture-level city', // 市/地级市
  pleaseSelectTheCityPrefectureLevelCity: 'Please select the city/prefecture-level city', // 请选择市/地级市
  countyDistrict: 'County/District', // 县/区
  pleaseSelectTheCountyDistrict: 'Please select the county/District', // 请选择县/区
  street: 'Township/Street/Community', // 乡镇/街道/社区
  pleaseEnterStreet: 'Please enter the township/street/community', // 请输入乡镇/街道/社区
  address: 'Address (street number)', // 地址(街道门牌号)
  pleaseEnterTheAddress: 'Please enter the address (street number)', // 请输入地址(街道门牌号)
  statusChangeTime: 'Status change time', // 状态改变时间
  pleaseSelectTheTimeOfStatusChange: 'Please select the time of status change', // 请选择状态改变时间
  partnerType: 'Partner Type', // 合作商类型
  pleaseSelectPartnerType: 'Please select partner type', // 请选择合作商类型
  companyName: 'Company Name', // 公司名称
  PleaseEnterTheCompanyName: 'Please enter the company name', // 请输入公司名称
  partnerGrouping: 'Partner Grouping', // 伙伴分组
  PleaseEnterThePartnerGrouping: 'Please enter the partner grouping', // 请输入伙伴分组
  businessPartners: 'Business partners', // 业务伙伴
  superiorPartnerCode: 'Superior partner code', // 上级合作商编码
  pleaseEnterTheSuperiorPartnerCode: 'Please enter the superior partner code', // 请输入上级合作商编码
  enterpriseType: 'Enterprise Type', // 企业类型
  pleaseSelectTheTypeOfEnterprise: 'Please select the type of enterprise', // 请选择企业类型
  enterpriseTypeName: 'Enterprise type name', // 企业类型名称
  legalPerson: 'Legal person', // 法人
  pleaseEnterTheLegalPerson: 'Please enter the legal person', // 请输入法人
  registeredAddress: 'Registered Address', // 注册地址
  pleaseEnterTheRegisteredAddress: 'Please enter the Registered Address', // 请输入注册地址
  registeredCapital: 'Registered capital (10K RMB)', // 注册资金(万元)
  pleaseEnterTheRegisteredCapital: 'Please enter the registered capital (10K RMB)', // 请输入注册资金(万元)
  contactPhoneNumber: 'Contact phone number', // 联系电话
  pleaseEnterYourContactNumber: 'Please enter your contact number', // 请输入联系电话
  email: 'Email', // 电子邮箱
  pleaseEnterYourEmailAddress: 'Please enter your email address', // 请输入电子邮箱
  taxpayerType: 'Taxpayer type', // 纳税人类型
  pleaseSelectTheTypeOfTaxpayer: 'Please select the type of taxpayer', // 请选择纳税人类型
  taxpayerTypeDescription: 'Taxpayer Type Description', // 纳税人类型描述
  taxpayerIdentificationNumberIDCcard: 'Taxpayer identification number/ID card', // 纳税人识别号/身份证
  pleaseEnterTheTaxpayerIdentificationNumberIDCard: 'Please enter the taxpayer identification number/ID card', // 请输入纳税人识别号/身份证
  accountOpeningBank: 'Account opening bank', // 开户行
  pleaseInputTheAccountOpeningBank: 'Please input the account opening bank', // 请输入开户行
  accountOfTheBank: 'Account of the bank', // 开户行账户
  pleaseEnterTheAccountOfTheBank: 'Please enter the account of the bank', // 请输入开户行账户
  validity: 'Validity', // 有效性
  pleaseSelectWhetherItIsValidOrNot: 'Please select whether it is valid or not', // 请选择是否有效
  materialCode: 'Material Code', // 物料编码
  pleaseEnterTheMaterialCode: 'Please enter the material code', // 请输入物料编码
  materialName: 'Material name', // 物料名称
  pleaseEnterTheMaterialName: 'Please enter the material name', // 请输入物料名称
  materialGroup: 'Material Group',
  pleaseSelectMaterialGroup: 'Please select material group', // 请选择物料组
  specification: 'Specification', // 规格
  pleaseEnterTheSpecification: 'Please enter the specification', // 请输入规格型号
  manufacturer: 'Manufacturer', // 厂家
  pleaseEnterTheManufacturer: 'Please enter the manufacturer', // 请输入生产厂家
  brand: 'Brand', // 品牌
  pleaseInputTheBrand: 'Please input the brand', // 请输入品牌
  level: 'Level', // 级别
  pleaseSelectTheLevel: 'Please select the level', // 请选择级别
  availableForSale: 'Available for sale', // 可销售
  pleaseChooseWhetherYouCanSell: 'Please choose whether you can sell', // 请选择是否可销售
  inventoryManagement: 'Inventory Management', // 库存管理
  pleaseSelectWhetherInventoryManagement: 'Please select whether inventory management', // 请选择是否库存管理
  inventoryUnit: 'Inventory unit', // 库存单位
  pleaseSelectTheInventoryUnit: 'Please select the inventory unit', // 请选择库存单位
  salesUnit: 'Sales unit', // 销售单位
  shelfLife: 'Shelf life (days)', // 保质期(天)
  pleaseEnterTheShelfLife: 'Please enter the shelf life (days)', // 请输入保质期(天)
  description: 'Description', // 描述
  pleaseEnterADescription: 'Please enter a description', // 请输入描述
  materialGroupClassification: 'Material group classification', // 物料组分类
  pleaseSelectTheMaterialGroupClassification: 'Please select the material group classification', // 请选择物料组分类
  warehouseCode: 'Warehouse code', // 仓库编码
  pleaseEnterTheWarehouseCode: 'Please enter the warehouse code', // 请输入仓库编码
  warehouseName: 'Warehouse name', // 仓库名称
  pleaseEnterTheWarehouseName: 'Please enter the warehouse name', // 请输入仓库名称
  ERPInventoryLocation: 'ERP inventory location', // ERP库存地点
  pleaseEnterTheERPInventoryLocation: 'Please enter the ERP inventory location', // 请输入ERP库存地点
  warehouseType: 'Warehouse type', // 仓储类型
  pleaseSelectTheWarehouseType: 'Please select the warehouse type', // 请选择仓储类型
  warehouseIdentification: 'Warehouse identification', // 仓库标识
  pleaseSelectTheWarehouseIdentification: 'Please select the warehouse identification', // 请选择仓库标识
  affiliatedWarehouse: 'Affiliated warehouse', // 所属仓库
  pleaseSelectTheAffiliatedWarehouse: 'Please select the affiliated warehouse', // 请选择所属仓库
  maximumCapacity: 'Maximum capacity(kg)', // 最大容量(kg)
  pleaseEnterTheMaximumCapacity: 'Please enter the maximum capacity(kg)', // 请输入最大容量(kg)
  organization: 'Organization', // 所属机构
  pleaseClickToSelectOrganization: 'Please click to select organization', // 请点击选择所属机构
  storageManagement: 'Storage Management', // 库位管理
  defaultWarehouseLocation: 'Default Warehouse Location', // 默认库位
  purchaseUnit: 'Purchase Unit', // 采购单位
  pleaseSelectthePurchasingUnit: 'Please select the purchasing unit', // 请选择采购单位
  purchaseInventoryConversionRate: 'Purchase - Inventory Conversion Rate', // 采购-库存换算率
  pleaseEnterTheConversionRate: 'Please enter the conversion rate', // 请输入换算率
  whetherValid: 'whether valid', // 是否有效
  factory: 'Factory', // 工厂
  pleaseSelectFactory: 'Please select factory', // 请选择工厂
  factoryCode: 'Factory Code', // 工厂编码
  pleaseSelectFactoryCode: 'Please select factory code', // 请选择工厂编码
  batchManagement: 'Batch management', // 批次管理
  convertibleMaterialName: 'Convertible Material Name', // 可转换物料名称
  pleaseEnterTheNameOfTheConvertibleMaterial: 'Please enter the name of the convertible material', // 请输入可转换物料名称
  defaultVersion: 'Default version', // 是否默认版本
  standardType: 'Standard Type', // 标准类型
  whetherToDistinguishBetweenSexes: 'Whether to distinguish between sexes', // 是否区分性别
  versionDescription: 'Version Description', // 版本描述
  pleaseEnterTheVersionDescription: 'Please enter the version description', // 请输入版本描述
  version: 'Version', // 版本
  pleaseEnterTheVersion: 'Please enter the version', // 请输入版本
  type: 'Type', // 类型
  eggFCRDuringLayingPeriod: 'Egg FCR during laying period', // 产蛋期料蛋比
  pleaseEnterTheEggFCRDuringTheEgglayingPeriod: 'Please enter the egg FCR during the egg-laying period', // 请输入产蛋期料蛋比
  totalUniformity: 'Total uniformity', // 全程均匀度
  pleaseEnterTheTotalUniformity: 'Please enter the total uniformity', // 请输入全程均匀度
  breedingStrain: 'Breeding strain', // 养殖品系
  pleaseSelectBreed: 'Please select a breed', //请选择品系
  effectiveDate: 'Effective Date', // 生效日期
  pleaseSelectEffectiveDate: 'Please enter effective date', // 请选择生效日期
  grower: 'Grower', // 养户
  pleaseSelectGrower: 'Please select a grower', // 请选择养户
  menuType: 'Menu Type', // 菜单类型
  firstLevelMenu: 'First level menu', // 一级菜单
  submenu: 'Submenu', // 子菜单
  buttonsPermissions: 'Buttons/Permissions', // 按钮/权限
  pleaseEnterMenuName: 'Please enter menu name', // 请输入菜单名称
  parentMenu: 'Parent menu', // 上级菜单
  pleaseSelectParentMenu: 'Please select parent menu', // 请选择上级菜单、请选择父级菜单
  menuPath: 'Menu Path', // 菜单路径
  pleaseEnterTheMenuPath: 'Please enter the menu path', // 请输入菜单路径
  frontComponents: 'Front-end components', // 前端组件
  pleaseEnterFrontComponents: 'Please enter front-end components', // 请输入前端组件
  defaultJumpAddress: 'Default Jump Address', // 默认跳转地址
  pleaseEnterRouterRedirect: 'Please enter router redirect', // 请输入路由参数 redirect
  authorizationID: 'Authorization ID', // 授权标识
  pleaseEnterAuthorization: 'Please enter the authorization ID, e.g.: user:list', // 请输入授权标识, 如: user:list
  authorizationPolicy: 'Authorization Policy', // 授权策略
  pleaseSelectAuthorizationPolicy: 'Please select an authorization policy', // 请选择授权策略
  menuIcon: 'Menu Icon', // 菜单图标
  clickToSelectIcon: 'Click to select icon', // 点击选择图标
  sort: 'Sort by', // 排序
  pleaseEnterSort: 'please Enter Sort', // 请输入序号
  pleaseEnterMenuSort: 'Please enter a menu sort', // 请输入菜单排序
  IfRouteMenu: 'Whether to route the menu', // 是否路由菜单
  hideRouting: 'Hide Routing', // 隐藏路由
  ifCacheRoutes: 'Whether to cache routes', //是否缓存路由
  aggregateRouting: 'Aggregate Routing', // 聚合路由
  baseFlag: 'baseFlag', // 可复制
  openMethod: 'Open method', // 打开方式
  external: 'External', // 外部
  internal: 'Internal', // 内部
  menuName: 'Menu name', // 菜单名称
  basicInformation: 'Basic Information', // 基本信息
  userInformation: 'user Information', // 用户信息
  departUser: 'depart User', // 部门角色
  organizationName: 'Organization Name', // 机构名称
  pleaseEnterOrganizationName: 'Please enter the name of the organization/department', // 请输入机构/部门名称
  upperDivision: 'Upper Division', // 上级部门
  none: 'None', // 无
  organizationCode: 'Organization Code', // 机构编码
  pleaseEnterTheOrganizationCode: 'Please enter the organization code', // 请输入机构编码
  orgShortCode: 'Org. Short Code', // 机构简码
  PleaseEnterShortCode: 'Please enter the organization short code', // 请输入机构简码
  organizationID: 'Organization identification code', // 机构标识码
  pleaseEnterOrgID: 'Please enter the organization identification code', // 请输入机构标识码
  personIncharge: 'Person in charge', // 负责人
  pleaseSelectPersonIncharge: 'Please select the person in charge', // 请选择负责人
  divisionHead: 'Division Head', // 分管领导
  pleaseSelectDivisionHead: 'Please select the division head', // 请选择分管领导
  departAdmin: 'Department Administrator', // 部门管理员
  pleaseSelectDepartAdmin: 'Please select the department administrator', // 请选择部门管理员
  orgType: 'Org.Type', // 机构类型
  pleaseSelectOrgType: 'Please select the type of organization', // 请选择机构类型
  serviceGroup: 'Service Group', // 服务组
  enabledOrNot: 'Enabled or not', // 是否启用
  enable: 'Enable', // 启用
  disable: 'Disable', // 禁用
  pleaseSelectAdopterCode: 'Please select the adopter code', // 请选择养户编码
  farms: 'Farms', // 养殖场
  cellPhoneNumber: 'Cell phone number', // 手机号
  pleaseInputCellPhoneNumber: 'Please input cell phone number', // 请输入手机号
  factoryType: 'Factory type', // 工厂类型
  pleaseSelectFactoryType: 'Please select factory type', // 请选择工厂类型
  uniformCreditCode: 'Uniform credit code', // 统一信用代码
  feedMillCode: 'Feed mill code', // 饲料厂编码
  pleaseEnterFeedMillCode: 'Please enter the feed mill code', // 请输入饲料厂编码
  costCenter: 'Cost Center', // 成本中心
  pleaseEnterCostCenter: 'Please enter cost center', // 请输入成本中心
  farmType: 'Farm Type', // 农场类型
  pleaseSelectFarmType: 'Please select farm type',// 请选择农场类型
  standardEmptyBarnPeriod: 'Standard empty barn period',// 标准空舍期
  farmManager: 'Farm Manager', // 场长
  pleaseEnterFarmManager: 'Please enter the farm manager',// 请输入场长
  farmProperties: 'Farm Properties', // 农场属性
  pleaseSelectFarmProperty: 'Please select farm property', // 请选择农场属性
  customer: 'Customer', // 所属客户
  pleaseEnterTheCustomerYouBelongTo: 'Please enter the customer you belong to', // 请输入所属客户
  buildingStatus: 'Building Status', // 栋舍状态
  pleaseSelectStatusOfBuilding: 'Please select the status of the building', // 请选择栋舍状态
  addressOnly: 'Address', // 地址
  pleaseSelectAddress: 'Please select the address', // 请选择地址
  capacity: 'Capacity', // 产能
  startUpTime: 'Start-up time', // 启用时间
  pleaseSelectStartUpTime: 'Please select the start-up time', // 请选择启用时间
  deactivationTime: 'Deactivation time', // 停用时间
  pleaseSelectDeactivationTime: 'Please select the deactivation time', // 请选择停用时间
  buildingLength: 'Building length', // 栋舍长度
  buildingWidth: 'Building width', // 栋舍宽度
  breedingArea: 'Breeding area', // 养殖面积
  breedingMethod: 'Breeding method', // 养殖方式
  pleaseSelectBreedingMethod: 'Please select the breeding method', // 请选择养殖方式
  verticalFanPower: 'Vertical fan power', // 竖向风机功率
  horizontalFanPower: 'Horizontal fan power', // 横向风机功率
  detailedAddress: 'Detailed address', // 详细地址
  pleaseEnterDetailAddress: 'Please enter detail address', // 请输入地址
  departmentPermissions: 'Department Permissions', // 部门权限
  pleaseEnterDaysInStandardVacancyPeriod: 'Please enter the number of days in the standard vacancy period', // 请输入标准空舍期天数
  oldPassword: 'Old password', // 旧密码
  pleaseEnterOldPassword: 'Please enter old password', // 请输入旧密码
  newPassword: 'New password', // 新密码
  pleaseEnterNewPassword: 'Please enter new password', // 请输入新密码
  confirmNewPassword: 'Confirm new password', // 确认新密码
  pleaseConfirmNewPassword: 'Please confirm new password', // 请输入新密码
  hatchery: 'Hatchery', // 孵化场
  pleaseSelectHatchery: 'please select hatchery', // 请选择孵化场
  inspectedWarehouse: 'Inspected warehouse', // 待检仓库
  pleaseSelectInspectedWarehouse: 'please select inspected warehouse', // 请选择待检仓库
  seedEggBatchNumber: 'Seed egg batch number', // 种蛋批号
  pleaseSelectSeedEggBatchNumber: 'please select seed egg batch number', // 请选择种蛋批号
  byProductWarehouse: 'By-product warehouse', // 副产品仓库
  eggWarehouse: 'Egg warehouse', // 种蛋仓库
  incubationFarm: 'Incubation farm', // 孵化农场
  pleaseSelectIncubationFarm: 'please select incubation farm', // 请选择孵化农场
  operationType: 'Operation type', // 操作类型
  pleaseSelectOperationType: 'please select operation type', // 请选择操作类型
  incubator: 'Incubator', // 孵化器
  pleaseSelectIncubator: 'please select incubator', // 请选择孵化器
  incubationBatchNumber: 'Incubation batch number', // 孵化批号
  pleaseSelectIncubationBatchNumber: 'please select incubator batch number', // 请选择孵化批号
  hatcher: 'Hatcher', // 出雏器
  pleaseSelectHatcher: 'please select hatcher', // 请选择出雏器
  immunizationDate: 'Immunization date', // 免疫日期
  pleaseSelectImmunizationDate: 'please select immunization date', // 请选择免疫日期
  roleName: 'Role Name', // 角色名称
  pleaseEnterRoleName: 'Please enter the role name', // 请输入角色名称
  languageName: 'languageName', // 语言名称
  languageCode: 'languageCode', // 语言编码
  pleaseEnterlanguageName: 'pleaseEnterlanguageName', // 请输入语言名称
  pleaseEnterlanguageCode: 'please Enter language Code', // 请输入语言编码
  languageDescription: 'language Description', // 多语言描述
  pleaseEnterLanguageDescription: 'please Enter Language Description', // 请输入多语言描述
  associatedDatabaseTable: 'associated Database Table', // 关联数据库表
  associatedDataField: 'associated Data Field', // 关联数据字段
  pleaseEnterAssociatedDataField: 'please Enter Associated Data Field', // 请输入关联数据字段
  pleaseEnterAssociatedDatabaseTable: 'please Enter Associated Database Table', // 请输入关联数据库表
  associatedBusinessType: 'associated Business Type', // 关联业务类型
  associatedEntityField: 'associated Entity Field', // 关联实体字段
  roleCode: 'Role Code', // 角色编码
  pleaseEnterRoleCode: 'Please enter the role code', // 请输入角色编码
  twoToThirtyCharactersInLength: '2 to 30 characters in length', // 长度在 2 到 30 个字符
  upToSixtyFourCharactersInLength: 'Up to 64 characters in length', // 长度不超过 64 个字符
  LessThanCharacters_126: 'No more than 126 characters in length', // 长度不超过 126 个字符
  noChineseCharactersAllowed: 'No Chinese characters can be entered for the role code', // 角色编码不可输入汉字
  userAccount: 'User account number', // 用户账号
  departUserName: 'depart User Name', // 部门角色名称
  pleaseEnterDepartUserName: 'please Enter Depart User Name', // 请输入部门角色名称
  departUserCode: 'depart User Code', // 部门角色编码
  pleaseEnterDepartUserCode: 'please Enter Depart User Code', // 请输入部门角色编码
  pleaseEnterDepartUserName: 'please Enter Depart User Name', // 请输入部门角色
  pleaseEnterAccount: 'Please enter the user account', // 请输入用户账号
  loginPassword: 'Login Password', // 登录密码
  pleaseEnterLoginPassword: 'Please enter the login password', // 请输入登录密码
  confirmPassword: 'Confirm password',// 确认密码
  pleaseConfirmLoginPassword: 'Please re-enter your login password', // 请重新输入登录密码
  userName: 'User Name', // 用户姓名
  pleaseEnterUsername: 'Please enter the user name',// 请输入用户姓名
  realName: 'Real Name', // 真实名字
  pleaseEnterRealName: 'Please enter the real Name', // 真实名字
  pleaseEnterCellPhoneNumber: 'Please enter cell phone',//请输入手机号
  userStatus: 'User Status', //用户状态
  employeeID: 'Employee ID', // 工号
  pleaseEnterWorkNumber: 'Please enter the work number', // 请输入工号
  position: 'Position', // 职务
  pleaseSelectJobTitle: 'Please select job title',// 请选择职务
  roleAssignment: 'Role assignment', // 角色分配
  pleaseSelectUserRole: 'Please select the user role', // 请选择用户角色
  departmentAssignment: 'Department Assignment', // 部门分配
  clickToSelectDepartment: 'Click to select department', // 点击选择部门
  tenantAssignment: 'Tenant Assignment', // 租户分配
  selectTenantAssignment: 'Please Select Tenant Assignment', // 请选择租户分配
  identity: 'Identity', // 身份
  normalUser: 'Normal user', // 普通用户
  supervisor: 'Supervisor', // 上级
  mainDepartment: 'main Department', // 归属部门
  pleaseSelectMainDepartment: 'Please select the main department', // 请选择归属部门
  responsibleDepartment: 'Responsible department', // 负责部门
  pleaseSelectDepartmentInCharge: 'Please select the department in charge', // 请选择负责部门
  image: 'Image', //  头像
  upload: 'Upload', // 上传
  birthday: 'Birthday', // 生日
  pleaseSelectYourBirthday: 'Please select your birthday', // 请选择生日
  workflowEngine: 'Workflow engine', // 工作流引擎
  pleaseSelectWhetherSynchronizeWorkflowEngine: 'Please select whether to synchronize the workflow engine', // 请选择是否同步工作流引擎
  male: '男', // 男
  female: '女', // 女
  pleaseEnterCorrectTelNumber: 'Please enter the correct landline number', // 请输入正确的座机号码
  deliveryOrderNo: 'Delivery order No', // 出雏单号
  pleaseSelectDeliveryOrderNo: 'please select delivery order No', // 请选择出雏单号
  hatchingDate: 'Hatching date', // 出雏日期
  pleaseSelectHatchingDate: 'please select hatching date', // 请选择出雏日期
  eggBatch: 'Egg batch', // 种蛋批次
  pleaseSelectEggBatch: 'please select egg batch', // 请选择种蛋批次
  numberOfEggKnocks: 'Number of egg knocks', // 敲蛋检查数
  pleaseEnterTheNumberOfEggKnocks: 'Please enter the number of egg knocks', // 请输入敲蛋检查数
  resetPassword: 'Reset password', // 重新设定密码
  thePasswordEnteredTwiceIsNotTheSame: 'The password entered twice is not the same!',//两次输入的密码不一样
  dictionaryName: 'Dictionary Name', // 字典名称
  pleaseEnterDictionaryName: 'Please enter dictionary name', // 请输入字典名称
  dictionaryNumber: 'Dictionary number', // 字典编号
  pleaseEnterDictionaryNum: 'Please enter dictionary number', // 请输入字典编号
  dictionaryFetch: 'Dictionary fetch', // 字典取回
  normal: 'normal', // 正常
  block: 'block', // 冻结
  pleaseEnterDataValue: 'Please enter the data value', // 请输入数据值
  dataValue: 'Data Value', // 数据值
  sortByVal: 'Sort by value', // 排序值
  smallerFront: 'The smaller the value the higher the front, support decimal', // 值越小越靠前，支持小数
  dataValuesCannotContainSpecialChar: 'Data values cannot contain special characters!', // 数据值不能包含特殊字符！
  dictionaryList: 'Dictionary List', // 字典列表
  deleteDictionaryCompletely: 'Delete dictionary completely', // 彻底删除字典
  areYouSureDeleteDictionaryCompletely: 'Are you sure you want to delete this dictionary item completely?',// 您确定要彻底删除这个字典项吗
  notePleaseBeCarefulItCannotBeRecoveredAfterDeletion: 'Note: Please be careful as it cannot be recovered after complete deletion.', // 注意：彻底删除后将无法恢复，请谨慎操作！
  categoryName: 'Category name', // 分类名称
  categoryCode: 'Category code',// 分类编码
  parentNode: 'Parent Node',// 父级节点
  pleaseSelectParentNode: 'Please select the parent node', // 请选择父级节点
  pleaseInputCategoryName: 'Please input the category name', // 请输入分类名称
  user: 'user', // 用户
  permissionsHeld: 'Permissions held', // 所拥有的权限
  pleaseSelectHigherDepartmentision: 'Please select a higher department', // 请选择上级部门
  fax: 'Fax', // 传真
  pleaseEnterFax: 'Please enter fax', // 请输入传真
  menu: 'menu', // 菜单
  ruleName: 'Rule name', // 规则名称
  pleaseEnterRuleName: 'Please enter the name of the rule', // 请输入规则名称
  ruleValue: 'Rule Value',// 规则值
  pleaseEnterRuleVal: 'Please enter the rule value', // 请输入规则值
  ruleField: 'Rule Field', // 规则字段
  pleaseEnterRuleField: 'Please enter the rule field', // 请输入规则字段
  conditionalRule: 'Conditional Rule', // 条件规则
  pleaseEnterConditionalRule: 'Please enter a conditional rule', // 请输入条件规则
  valid: 'Valid', // 有效
  invalid: 'Invalid', // 无效
  pleaseEnterDepartmentName: 'Please enter the department name', // 请输入部门名称
  department: 'Department', // 部门
  pleaseSelectServiceDepartment: 'Please select department', // 请选择部门
  eRPSingleNumber: 'ERP Single Number',//ERP单号
  pleaseEnterERPSingleNumber: 'Please enter the ERP single number', // 请输入ERP单号
  storehouseType: 'Warehouse Type',//仓库类型
  pleaseSelectStorehouseType: 'Please select warehouse type',//请选择仓库类型
  pleaseSelectFarms: 'Please Select Farms', // 请选择养殖场
  farmingBatch: 'Farming Batch',//养殖批次
  pleaseEnterFarmingBatch: 'Please Enter Farming Batch', // 请输入养殖批次
  applicant: 'applicant',//申请人
  pleaseSelectApplicant: 'Please select applicant',//请选择申请人
  pleaseEnterTheDocumentNumber: 'Please enter the document number',//请输入单据编号
  breedingCycle: 'Breeding cycle',//养殖周期
  pleaseEnterTheBreedingPeriod: 'Please enter the breeding period',//请输入养殖周期
  plannedNumberOfSeedlings: 'Planned number of seedlings',//计划进苗数量
  giftAmount: 'Gift amount',//赠与数量
  pleaseEnterTheGiftAmount: 'Please enter the gift amount',//请输入赠与数量
  theNumberOfShipments: 'The number of shipments',//发货数量
  pleaseEnterTheShippingQuantity: 'Please enter the shipping quantity',//请输入发货数量
  plannedDateOfSeedling: 'Planned date of seedling',//计划进苗日期
  pleaseSelectThePlannedDateOfSeedling: 'Please select the planned date of seedling',//请选择计划进苗日期
  serviceCompany: 'Service company',//服务公司
  pleaseSelectAServiceCompany: 'Please select a service company',//请选择服务公司
  affiliatedCompany: 'Affiliated company',//所属公司
  pleaseSelectaffiliatedCompany: 'Please select affiliated company',//请选择所属公司
  affiliatedTechnicalStaffNumber: 'Affiliated technical staff number',//所属技术员工号
  pleaseSelectaffiliatedTechnicalStaffNumber: 'Please select affiliated technical staff number',//请选择所属技术员工号
  whetherSelfEmployed: 'Whether self-employed',//是否个体户
  pleaseSelectWhetherSelfEmployed: 'Please select whether self-employed',//请选择是否个体户
  whetherEnterprise: 'Whether enterprise',//是否企业
  pleaseSelectWhetherEnterprise: 'Please select whether enterprise',//是否企业
  growerStatus: 'Grower Status',//养户状态
  pleaseSelectGrowerStatus: 'Please select grower status',//请选择养户状态
  statusChangeTime: 'Status change time',//状态改变时间
  pleaseSelectTheTimeOfStatusChange: 'Please select the time of status change',//请选择状态改变时间
  distanceToCompany: 'Distance to company',//距公司公里数
  pleaseEnterTheNumberOfKilometersFromTheCompany: 'Please enter the number of kilometers from the company',//请输入距离公司公里数
  country: 'Country',//国家
  province: 'Province',//省份
  city: 'City',//市/地级市
  county: 'County',//县/区
  street: 'Street',//乡镇/街道/社区
  pleaseEnterTheStreet: 'Please enter the street',//请输入乡镇/街道/社区
  address: 'Address',//地址(街道门牌号)
  pleaseEnterTheAddress: 'Please enter the address',//请输入地址(街道门牌号)
  telephone: 'Telephone',//电话
  pleaseEnterYourPhoneNumber: 'Please enter your phone number',//请输入电话
  spouseName: 'Spouse\'s  name',//配偶姓名
  pleaseEnterYourSpouseName: 'Please enter your spouse\'s name',//请输入配偶姓名
  spouseCellPhone: 'Spouse\'s cell phone',//配偶手机
  pleaseEnterYourSpouseCellPhone: 'Please enter your spouse\'s cell phone',//请输入配偶手机
  spouseIDNumber: 'Spouse ID number',//配偶身份证号
  pleaseEnterYourSpouseIDNumber: 'Please enter your spouse\'s ID number',//请输入配偶身份证号
  homeAddress: 'Home Address',//家庭地址
  pleaseEnterYourHomeAddress: 'Please enter your home address',//请输入家庭地址
  bankAccount: 'Bank Account',//开户银行
  pleaseInputTheBankAccount: 'Please input the bank account',//请输入开户银行
  bankAddress: 'Bank Address',//开户行地址
  pleaseEnterTheBankAddress: 'Please enter the bank address',//请输入开户行地址
  bankCardNumber: 'Bank Card Number',//银行卡号
  pleaseInputTheBankCardNumber: 'Please input the bank card number',//请输入银行卡号
  validOrNot: 'Valid or not',//是否有效
  pleaseChooseWhetherItIsValidOrNot: 'Please choose whether it is valid or not',//请选择是否有效
  remarks: 'Remarks',//备注
  pleaseEnterANote: 'Please enter a note',//请输入备注
  pleaseEnterTheCorrectIDCardNumber: 'Please enter the correct ID card number',//请输入正确的身份证号
  pleaseEnterTheCorrectIDNumberOfYourSpouse: 'Please enter the correct ID number of your spouse',//请输入正确的配偶身份证号
  pleaseEnterTheCorrectCellPhoneNumber: 'Please enter the correct cell phone number',//请输入正确的手机号码
  sureToSubmit: 'Sure to submit?',//确定提交吗
  oKToWriteOff: 'OK to write off?',//确定冲销吗
  applicationOrderNo: 'Application order No.',//申请单号
  pleaseSelectTheApplicationNo: 'Please select the application No.',//请选择申请单号
  shippingWarehouse: 'Shipping Warehouse',//发货仓库
  contractID: 'Contract ID',//合同号
  pleaseInputTheContractID: 'Please input the Contract ID',//请输入合同号
  detailPrimaryKey: 'Detail primary key',//明细主键
  pleaseSelectLotNo: 'Please select lot No.',//请选择批号
  mustBeOrPositiveInteger: 'must be or positive integer',//必须是或者正整数
  settlementAmount: 'Settlement amount',//结算金额
  partyA: 'Party A',//甲方公司
  pleaseSelectPartyA: 'Please select party A',//请选择甲方公司
  partyB: 'Party B',//乙方养户
  pleaseSelectPartyB: 'Please select Party B',//请选择乙方养户
  contracName: 'Contract name',//合同名称
  pleaseEnterTheContractName: 'Please enter the contract name',//请输入合同名称
  cooperationMode: 'Cooperation mode',//合作模式
  pleaseSelectTheCooperationMode: 'Please select the cooperation mode',//请选择合作模式
  contractType: 'Contract type',//合同类型
  pleaseSelectTheContractType: 'Please select the contract type',//请选择合同类型
  dateOfSigning: 'Date of Signing',//签订日期
  pleaseSelectTheDateOfSigning: 'Please select the date of signing',//请选择签订日期
  signingPlace: 'Signing place',//签订地点
  pleaseEnterThePlaceOfSigning: 'Please enter the place of signing',//请输入签订地点
  industry: 'Industry',//行业
  pleaseInputTheIndustry: 'Please input the industry',//请输入行业
  contractText: 'Contract text',//合同文本
  pleaseEnterTheContractText: 'Please enter the contract text',//请输入合同文本
  whetherStandardText: 'Whether standard text',//是否标准文本
  pleaseSelectWhetherTheStandardContractText: 'Please select whether the standard contract text',//请选择是否标准合同文本
  currency: 'Currency',//币种
  pleaseEnterTheCurrency: 'Please enter the currency',//请输入币种
  localCurrency: 'Local currency',//本位币
  pleaseEnterTheLocalCurrency: 'Please enter the local currency',//请输入本位币
  conversionRate: 'Conversion Rate',//折本汇率
  pleaseEnterTheConversionRate: 'Please enter the conversion rate',//请输入折本汇率
  breedingCategory: 'Breeding category',//养殖品类
  pleaseSelectSpecies: 'Please select species',//请选择品类
  breedingStrain: 'Breeding strain',//养殖品系
  pleaseSelectAStrain: 'Please select a strain',//请选择品系
  generation: 'Generation',//代次
  gender: 'Gender',//养殖性别
  pleaseSelectSpecies: 'Please select species',//请选择物种
  breederAdministrator: 'Breeder Administrator',//养户管理员
  pleaseEnterTheBreederAdministrator: 'Please enter the breeder administrator',//请输入养户管理员
  pleaseSelectTheServiceGroup: 'Please select the service group',//请选择服务组
  enteringPerson: 'Entering person',//录入人
  serviceTeamLeader: 'Service Team Leader',//服务组长
  pleaseEnterTheServiceGroupLeader: 'Please enter the service group leader',//请输入服务组长
  marketingTeamLeader: 'Marketing Team Leader',//营销组长
  pleaseEnterTheMarketingTeamLeader: 'Please enter the marketing team leader',//请输入营销组长
  salesperson: 'Salesperson',//营销员
  pleaseEnterTheMarketingStaff: 'Please enter the marketing staff',//请输入营销员
  changeOfContractCode: 'Change of contract code',//变更合同编码
  pleaseEnterTheChangeContractCode: 'Please enter the change contract code',//请输入变更合同编码
  changeTime: 'Change time',//变更时间
  pleaseSelectTheTimeOfChange: 'Please select the time of change',//请选择变更时间
  reasonForChange: 'Reason for change',//变更原因
  pleaseEnterTheReasonForChange: 'Please enter the reason for change',//请输入变更原因
  modifyTheContractText: 'Modify the contract text',//修改合同文本
  pleaseEnterTheTextOfTheModifiedContract: 'Please enter the text of the modified contract',//请输入修改合同文本
  breedingStandard: 'Breeding standard',//养殖标准
  pleaseEnteANumber: 'Please enter a number',//请输入数字
  age: 'Age',//饲养天数
  pleaseEnterAge: 'Please enter age',//请输入饲养天数
  numberOfContracts: 'Number of contracts',//合同数量
  pleaseEnterTheNumberOfContracts: 'Please enter the number of contracts',//请输入合同数量
  day: 'day',//天
  only: 'only',//只
  maximumLivability: 'Maximum livability',//成活率上限
  pleaseEnterTheUpperLimitOfLivability: 'Please enter the upper limit of livability',//请输入标准成活率上限
  minimumLivability: 'Minimum Livability',//成活率下限
  pleaseEnteTheMinimumLivability: 'Please enter the minimum livability',//请输入标准成活率下限
  wtandardLivability: 'Standard livability',//标准成活率
  pleaseEnterTheStandardLivability: 'Please enter the standard livability',//请输入标准成活率
  weightLimit: 'Weight limit',//体重上限
  pleaseEnterTheUpperLimitOfStandardWeight: 'Please enter the upper limit of standard weight',//请输入标准体重上限
  lowerWeightLimit: 'Lower weight limit',//体重下限
  pleaseEnterTheLowerStandardWeightLimit: 'Please enter the lower standard weight limit',//请输入标准体重下限
  standardWeight: 'Standard weight',//标准体重
  pleaseEnterStandardWeight: 'Please enter standard weight',//请输入标准体重
  uniformityUpperLimit: 'Uniformity upper limit',//均匀度上限
  pleaseEnterTheUpperLimitOfStandardEvenness: 'Please enter the upper limit of standard evenness',//请输入标准均匀度上限
  lowerLimitOfUniformity: 'Lower limit of uniformity',//均匀度下限
  pleaseEnterTheLowerLimitOfStandardUniformity: 'Please enter the lower limit of standard uniformity',//请输入标准均匀度下限
  standardUniformity: 'Standard uniformity',//标准均匀度
  pleaseEnterTheStandardUniformity: 'Please enter the standard uniformity',//请输入标准均匀度
  upperLimitOfConsumption: 'Upper limit of consumption',//耗用量上限
  pleasEnterTheUpperLimitOfConsumptionPerUnit: 'Please enter the upper limit of consumption per unit',//请输入单只耗用量上限
  lowerLimitOfConsumption: 'Lower limit of consumption',//耗用量下限
  pleaseEnterTheLowerLimitOfConsumptionPerUnit: 'Please enter the lower limit of consumption per unit',//请输入单只耗用量下限
  standardConsumption: 'Standard consumption',//标准耗用量
  pleaseEnterTheConsumptionAmountPerUnit: 'Please enter the consumption amount per unit',//请输入单只耗用量
  upperLimitOfMeatRatio: 'Upper limit of meat ratio',//料肉比上限
  pleaseEnterTheUpperLimitOfStandardMeatRatio: 'Please enter the upper limit of standard meat ratio',//请输入标准料肉比上限
  lowerLimitOfMeatRatio: 'Lower limit of meat ratio',//料肉比下限
  pleaseEnterTheLowerLimitOfStandardMeatRatio: 'Please enter the lower limit of standard meat ratio',//请输入标准料肉比下限
  standardMeatRatio: 'Standard Meat Ratio',//标准料肉比
  pleaseEnterTheStandardMeatRatio: 'Please enter the standard meat ratio',//请输入标准料肉比
  pleaseEnterAWholeNumber: 'Please enter a whole number',//请输入整数
  pleaseEnterANumber: 'Please enter a number',//请输入数字
  feather: 'feather',//羽
  feedCost: 'Feed Cost',//饲料成本
  pleaseEnterTheFeedCostStandard: 'Please enter the feed cost standard',//请输入饲料成本标准
  rMBBird: 'RMB/Bird',//元/只
  medicineCost: 'Medicine cost',//药品成本
  pleaseInputTheCostStandardOfMedicine: 'Please input the cost standard of medicine',//请输入药品成本标准
  maleBirdAGrade: 'Male bird A grade',//公禽A级
  pleaseEnterTheUnitPriceForTheRecoveryOfMaleBirdAGrade: 'Please enter the unit price for the recovery of male bird A grade',//请输入公禽A级回收单价
  femaleAGrade: 'Female A grade',//母禽A级
  pleaseEnterTheUnitPriceForTheRecoveryOfFemaleBirdAGrade: 'Please enter the unit price for the recovery of female bird A grade',//请输入母禽A级回收单价
  maleB: 'Male B',//公禽B级
  pleaseEnterTheUnitPriceOfMaleBirdBGrade: 'Please enter the unit price of male bird B grade',//请输入公禽B级回收单价
  femaleBirdBGrade: 'Female bird B grade',//母禽B级
  pleaseEnterTheUnitPriceOfBGradeOfFemaleBirds: 'Please enter the unit price of B grade of female birds',//请输入母禽B级回收单价
  maleBirdResidual: 'Male bird residual',//公禽残次
  pleaseEnterTheUnitPriceOfMaleBirdResidualRecovery: 'Please enter the unit price of male bird residual recovery',//请输入公禽残次回收单价
  femaleBirdResidual: 'Female bird residual',//母禽残次
  pleaseEnterTheUnitPriceOfFemalePoultryResidualRecovery: 'Please enter the unit price of female poultry residual recovery',//请输入母禽残次回收单价
  yuanKg: 'Yuan/Kg',//元/Kg
  settlementBasis: 'Settlement basis',//结算依据
  pleaseSelectTheBasisOfSettlement: 'Please select the basis of settlement',//请选择结算依据
  standardDailyFeePerAnimal: 'Standard daily fee per animal',//每只每日标准代养费
  pleaseEnterTheStandardDailyFeePerAnimal: 'Please enter the standard daily fee per animal',//请输入每只每日标准代养费
  dividendPrice: 'Dividend Price',//分红价格
  pleaseEnterTheDividendPrice: 'Please enter the dividend price',//请输入分红价格
  companyCapitalPreservationPoint: 'Company\'s capital preservation point',//公司保本点
  pleaseEnterTheCompanyCapitalPreservationPoint: 'Please enter the company\'s capital preservation point',//请输入公司保本点
  capitalPreservationPointForFarmers: 'Capital preservation point for farmers',//养户保本点
  pleaseInputTheCapitalPreservationPointOfTheAdopter: 'Please input the capital preservation point of the adopter',//请输入养户保本点
  profitRatioOfPartyA: 'Profit ratio of Party A',//甲方盈利比例
  pleaseEnterTheProfitRatioOfPartyA: 'Please enter the profit ratio of Party A',//请输入盈利比例甲方
  profitRatioOfPartyB: 'Profit ratio of Party B',//乙方盈利比例
  pleaseInputTheProfitRatioOfPartyB: 'Please input the profit ratio of Party B',//请输入盈利比例乙方
  LossRatioOfPartyA: 'Loss ratio of Party A',//甲方亏损比例
  pleaseEnterThePercentageOfLossForPartyA: 'Please enter the percentage of loss for Party A',//请输入亏损比例甲方
  partyBLossRatio: 'Party B loss ratio',//乙方亏损比例
  pleaseInputLossRatioPartyB: 'Please input loss ratio Party B',//请输入亏损比例乙方
  settlementAmountForPartyA: 'Settlement amount for Party A',//甲方结算金额
  settlementAmountOfPartyB: 'Settlement amount of Party B',//乙方结算金额
  yuan: 'Yuan',//元
  pleaseEnterTheCorrectAmount: 'Please enter the correct amount',//请输入正确的金额
  pleaseEnterTheUnitPrice: 'Please enter the unit price',//请输入单价
  balance: 'Balance',//余额
  pleaseEnterTheBalance: 'Please enter the balance',//请输入余额
  amount: 'Amount',//金额
  pleaseEnterTheAmount: 'Please enter the amount',//请输入金额
  unitPrice: 'Unit Price',//单价
  maximumLength6Bits: 'Maximum length 6 bits',//最大长度6位
  planNo: 'Plan No.',//计划编号
  pleaseEnterPlanNo: 'Please enter plan no.',//请输入计划编号
  planDescription: 'Plan Description',// 计划描述
  pleaseEnterPlanDescription: 'Please enter plan description',//请输入计划描述
  batchNo: 'Batch No.',//养殖批次
  pleaseSelectBatchNo: 'Please select batch no.',//请选择养殖批次
  noPicture: 'No picture',//无图片
  noFile: 'No file',//无文件
  download: 'Download',//下载
  totalPlacement: 'Total Placement',//进苗总量
  plannedPlacementDate: 'Planned Placement Date',//计划进苗日期
  confirmationTime: 'Confirmation time',//确认时间
  reviewStatus: 'Review status',//审核状态
  maximumLength6Bits: 'Maximum length 6 bits',//最大长度6位
  confirmSynchronization: 'Confirm synchronization',//确定同步
  pleaseSelectAData: 'Please select a data',//请选择一条数据
  thePlacementDateMustBeGreaterThanOrEqualToTheStartDate: 'The placement date must be greater than or equal to the start date',//入舍日期必须大于等于批次空舍开始日期
  mustBeGreaterThanOrEqualTo0: 'Must be greater than or equal to 0',//必须大于等于0
  ifYouDoNotHaveAnAuditorYouCannotSubmit: 'If you do not have an auditor, you cannot submit',//没有设置审核人员,不能提交
  reviewer: 'Reviewer',//审核人
  deliveryFarm: 'Delivery Farm',//交货农场
  sourceOrderType: 'Source Order Type',//源单类型
  pleaseSelectTheSourceOrderType: 'Please select the source order type',//请选择源单类型
  auxiliaryQuantity: 'Auxiliary quantity',//辅助数量
  confirmCopy: 'Confirm Copy',//确定复制
  confrimToGenerateAStatement: 'Confrim to generate a statement',//确定生成结算单
  pleaseSelectTheBreedingStandard: 'Please select the breeding standard',//请选择养殖标准
  pleaseEnterTheDocumentNo: 'Please enter the document No.',//请输入单据编号
  pleaseSelectTheFarmNo: 'Please select the farm No.',//请选择养殖场编号
  pleaseSelectTheFarmerNo: 'Please select the farmer No.',//请选择养户编号
  pleaseSelectTheStrain: 'Please select the strain',//请选择品系
  speciesClassification: 'Species classification',//物种分类
  strain: 'Strain',//品系
  pleaseSelectSpecies: 'Please select species',//请选择品类
  pleaseInputTheBreedingCycle: 'Please input the breeding cycle',//请输入养殖周期
  plannedNoOfPlacement: 'Planned No. of placement',//计划进苗数量
  pleaseInputThePlannedNoOfPlacement: 'Please input the planned No. of placement',//请输入计划进苗数量
  noOfGrants: 'No. of grants',//赠与数量
  pleaseEnterTheNoOfGifts: 'Please enter the No. of gifts',//请输入赠与数量
  noOfShipments: 'No. of shipments',//发货数量
  pleaseEnterTheNoOfShipments: 'Please enter the No. of shipments',//请输入发货数量
  plannedDateOfPlacement: 'Planned date of placement',//计划进苗日期
  pleaseSelectThePlannedDateOfPlacement: 'Please select the planned date of placement',//请选择计划进苗日期
  pleaseInputTheApplicant: 'Please input the applicant',//请输入申请人
  productLine: 'Product Line',//产品线
  pleaseSelectTheProductLine: 'Please select the product line',//请选择产品线
  auditStatus: 'Audit Status',//审核状态
  pleaseSelectTheAuditStatus: 'Please select the audit status',//请选择审核状态
  validOrNot: 'Valid or not',//是否有效
  pleaseChooseWhetherItIsValidOrNot: 'Please choose whether it is valid or not',//请选择是否有效
  confirmedBy: 'Confirmed by',//确认人
  pleaseEnterThePersonWhoConfirmed: 'Please enter the person who confirmed',//请输入确认人
  pleaseEnterTheBatchNo: 'Please enter the Batch No.',//请输入养殖批次编号
  pleaseEnterFarmNo: 'Please enter farm No.',//请输入养殖场编号
  pleaseEnterTheGrowerNo: 'Please enter the grower No.',//请输入养户编号
  pleaseEnterTheContractId: 'Please enter the Contract ID',//请输入合同编号
  pleaseEnterTheNoOfGrants: 'Please enter the No. of grants',//请输入赠送数量
  pleaseSelectTheCompanyCode: 'Please select the company code',//请选择公司编码
  pleaseSelectFarmCode: 'Please select farm code',//请选择农场编码
  pleaseSelectWarehouseCode: 'Please select warehouse code',//请选择仓库编码
  applicationTime: 'Application time',//申请时间
  pleaseSelectTheApplicationTime: 'Please select the application time',//请选择申请时间
  pleaseEnterTheDocumentCategory: 'Please enter the document category',//请输入单据类别
  billingPeriod: 'Billing period',//单据账期
  pleaseSelectTheBillablePeriod: 'Please select the billable period',//请选择单据账期
  demandTime: 'Demand Time',//需求时间
  pleaseSelectTheDemandTime: 'Please select the demand time',//请选择需求时间
  requestedArrivalTime: 'Requested arrival time',//要求到货时间
  pleaseSelectTheRequiredArrivalTime: 'Please select the required arrival time',//请选择要求到货时间
  qtyRequested: 'Qty Requested',//申请数量
  pleaseEnterTheQtyRequested: 'Please enter the Qty requested',//请输入申请数量
  pleaseSelectTheQtyToBeShipped: 'Please select the Qty to be shipped',//请选择发货数量
  receivedQty: 'Received Qty',//收货数量
  pleaseEnterTheNoOfGoodsReceived: 'Please enter the No. of goods received',//请输入收货数量
  pleaseEnterTheUnit: 'Please enter the unit',//请输入单位
  unitNo: 'Unit No.',//单位编号
  pleaseEnterTheUnitNo: 'Please enter the unit No.',//请输入单位编号
  costUnitPrice: 'Cost Unit Price',//成本单价
  pleaseEnterTheCostUnitPrice: 'Please enter the cost unit price',//请输入成本单价
  pleaseEnterTheSettlementUnitPrice: 'Please enter the settlement unit price',//请输入结算单价
  documentNo: 'Document No.',//单据编号
  dateOfDemand: 'Date of demand',//需求日期
  chickenApplicationForm: 'Chicken application form',//鸡苗申请单
  pleaseSelectChickenApplicationForm: 'Please select chicken application form',//请选择鸡苗申请单
  species: 'Species',//品种
  plannedDateOfPlacement: 'Planned date of placement',//进苗计划日期
  pleaseEnterThePlannedDateOfPlacement: 'Please enter the planned date of placement',//请输入进苗计划日期
  shippingWarehouse: 'Shipping warehouse',//发货仓库
  pleaseSelectTheWarehouseForChickenDelivery: 'Please select the warehouse for chicken delivery',//请选择鸡发货仓库
  pleaseEnterTheSettlementAmount: 'Please enter the settlement amount',//请输入结算金额
  pleaseEnterTheType: 'Please enter the type',//请输入类型
  documentDetails: 'Document Details',//单据明细
  breedingLot: 'Breeding lot',//养殖批次
  entryType: 'Entry type',//入库类型
  materialDetails: 'Material Details',//物料明细
  death: 'Death',// 死亡数量
  pleaseEnterTheNoOfDeaths: 'Please enter the No. of deaths',//请输入死亡数量
  noOfCulling: 'No. of culling',//淘汰数量
  pleaseEnterTheNoOfCulling: 'Please enter the No. of culling',//请输入淘汰数量
  temperature: 'Temperature',//温度
  pleaseEnterTheTemperature: 'Please enter the temperature',//请输入温度
  humidity: 'Humidity',//湿度
  pleaseInputHumidity: 'Please input humidity',//请输入湿度
  batchNumber: 'Batch Number',//批次编号
  pleaseEnterTheBatchNumber: 'Please enter the batch number',//请输入批次编号
  batchName: 'Batch Name',//批次名称
  pleaseEnterTheBatchName: 'Please enter the batch name',//请输入批次名称
  pleaseSelectTheContractNumber: 'Please select the contract number',//请选择合同编号
  feedingCycle: 'Feeding cycle',//饲养周期
  pleaseEnterTheFeedingCycle: 'Please enter the feeding cycle',//请输入饲养周期
  species: 'Species',//品类
  pleaseSelectStrain: 'Please select strain',//请选择品类
  strain: 'strain',//品系
  pleaseSelectAStrain: 'Please select a strain',//请选择品系
  generation: 'Generation',//代次
  initialAge: 'Initial age',//初始日龄
  pleaseEnterTheInitialAge: 'Please enter the initial age',//请输入初始日龄
  plannedNumberOfChicks: 'Planned number of chicks',//计划入雏数量
  pleaseEnterThePlannedNumberOfChicks: 'Please enter the planned number of chicks',//请输入计划入雏数量
  actualNumberOfChicks: 'Actual number of chicks',//实际入雏数量
  pleaseEnterTheActualNumberOfChicks: 'Please enter the actual number of chicks',//请输入实际入雏数量
  remarks: 'Remarks',//备注
  pleaseEnterAComment: 'Please enter a comment',//请输入备注
  contractNo: 'Contract No',//合同编号
  costItemClassificationCode: 'Cost item classification code',//费用项分类编码
  pleaseEnterTheCostItemClassificationCode: 'Please enter the cost item classification code',//请输入费用项分类编码
  costItemClassification: 'Cost item classification',//费用项分类
  pleaseEnterTheCostItemClassification: 'Please enter the cost item classification',//请输入费用项分类
  pleaseSelectAStatus: 'Please select a status',//请选择状态
  pleaseEnterTheSupplierCode: 'Please enter the supplier code',//请输入供应商编码
  dateOfDemand: 'Date of demand',//需求日期
  materialNumber: 'Material No.',//物料编号
  pleaseSelectTheMaterialNo: 'Please select the material No.',//请选择物料编号
  pleaseFillInBatchNo: 'Please fill in Batch No.',//请填写饲养批次
  pleaseEnterTheMaterialNo: 'Please enter the material No.',//请输入物料编号
  materialCommonName: 'Material Common Name',//物料通用名
  pleaseEnterTheCommonNameOfTheMaterial: 'Please enter the common name of the material',//请输入物料通用名
  synchronousUpdate: 'Synchronous update',//同步更新
  model: 'Model',//型号
  unitOfMeasurement: 'Unit of measurement',//计量单位
  description: 'Description',//说明描述
  materialCommonNameFileNo: 'Material Common Name File No.',//物料通用名档案编号
  pleaseSelectTheMaterialCommonNameFileNo: 'Please select the material common name file No.',//请选择物料通用名档案编号
  pleaseEnterTheMaterialCommonName: 'Please enter the material common name',//请输入物料通用名
  contractCode: 'Contract code',//合同编码
  pleaseSelectTheContractCode: 'Please select the contract code',//请选择合同编码
  batchCode: 'Batch code',//批次编码
  pleaseSelectBatchCode: 'Please select batch code',//请选择批次编码
  contracts: 'Contracts',//合同
  batch: 'Batch',//批次
  pleaseSelectFarm: 'Please select farm',//请选择养殖场
  receipt: 'Receipt',//领用
  confirmApproval: 'Confirm Approval',//确定审核通过
  securityDepositOperation: 'Security Deposit Operation',//保证金操作
  bookkeepingDate: 'Bookkeeping date',//记账日期
  applicationInitiationTime: 'Application Initiation Time',//申请发起时间
  lastApprover: 'Last approver',//最后审批人
  lastApprovalTime: 'Last approval time',//最后审批时间
  pleaseSelectContract: 'Please select contract',//请选择合同
  pleaseSelectBatch: 'Please select batch',//请选择批次
  batchSize: 'Batch size',//批次规模
  businessDate: 'Business date',//业务日期
  businessType: 'Business type',//业务类型
  operationTime: 'Operation time',//操作时间
  placementQty: 'Placement Qty',//入雏数量
  currentStock: 'Current Stock',//当前存栏数
  reasonForApplication: 'Reason for application',//申请原因
  auditStatus: 'Audit Status',//审核状态
  dateOfApplication: 'Date of application',//申请日期
  finalApprover: 'Final Approver',//最后审批人
  pleaseSelectContractNo: 'Please select contract No.',//请选择放养合同号
  applicationType: 'Application Type',//申请类型
  totalAmount: 'Total amount',//金额合计
  accountDate: 'Account Date',//记账日期
  applicationInitiationDate: 'Application Initiation Date',//申请发起日期
  cooperationModel: 'Cooperation Model',//合作模式
  partyBDividendRatio: 'Party B Dividend Ratio',//乙方分红比例
  marketPrice: 'Market price',//市场价格
  exceedingPrice: 'Exceeding price',//超出价格
  stocker: 'Stocker',//放养员
  stockerInCharge: 'Stocker in charge',//放养负责人
  totalWeight: 'Total weight',//出栏总重量
  dividendAmount: 'Dividend amount',//分红金额
  okToUpdateTheStatement: 'OK to update the statement',//确定更新结算单
  okToWithdraw: 'OK to withdraw?',//确定撤回吗
  withdraw: 'Withdraw',//撤回
  contractName: 'Contract name',//合同名称
  cooperationMode: 'Cooperation mode',//合作模式
  contractType: 'Contract type',//合同类型
  dateOfContractSigning: 'Date of contract signing',//合同签订日期
  contractEffectiveDate: 'Contract effective date',//合同生效日期
  contractTerminationDate: 'Contract termination date',//合同终止日期
  placeOfSigning: 'Place of Signing',//签订地点
  sector: 'Sector',//部门
  enteredBy: 'Entered by',//录入人
  conversionRate: 'Conversion rate',//折本汇率
  fosterCareAdministrator: 'Foster Care Administrator',//养户管理员
  contractVersion: 'Contract Version',//合同版本
  pleaseEnterTheBatchNo: 'Please enter the batch No.',//请输入批次编号
  batchOperation: 'Batch operation',//批量操作
  sureToWriteOff: 'Sure to write off?',//确定冲销吗
  sureToDelete: 'Sure to delete?',//确定删除吗
  material: 'Material',//物料
  pleaseSelectMaterial: 'Please select material',//请选择物料
  effectiveTime: 'Effective time',//生效时间
  expirationTime: 'Expiration time',//失效时间
  isTheMaterialValid: 'Is the material valid',//物料是否有效
  pleaseSelectACompany: 'Please select a company',//请选择公司
  pleaseSelectAContract: 'Please select a contract',//请选择合同
  formula: 'Formula',//公式
  pleaseEnterAFormula: 'Please enter a formula',//请输入公式
  substituteMaintenanceFeeCalculationFormula: 'Substitute maintenance fee calculation formula',//代养费计算公式
  confirmDeletionOfThisItem: 'Confirm deletion of this item',//确认删除此项
  verify: 'Verify',//验证
  variables: 'Variables',//变量
  operators: 'Operators',//运算符
  pleaseEnterANo: 'Please enter a No.',//请输入数字
  marketPriceRevenue: 'Market Price Revenue',//市场价收入
  contractPriceRevenue: 'Contract price revenue',//合同价收入
  specificFeedCost: 'Specific feed cost',//特定饲料成本
  chickCost: 'Chick cost',//鸡苗成本
  feedCost: 'Feed cost',//饲料成本
  drugCost: 'Drug cost',//药品成本
  vaccineCost: 'Vaccine cost',//疫苗成本
  totalCost: 'Total Cost',//总费用
  totalReward: 'Total Reward',//总奖励
  totalPenalty: 'Total Penalty',//总处罚
  catchQty: 'Catch Qty',//出栏只数
  catchWeight: 'Catch Weight',//出栏重量
  contractAverageWeight: 'Contract average weight',//合同均重
  unitSurrogateBreedingFee: 'Unit surrogate breeding fee',//单位代养费
  unitManagementCost: 'Unit management cost',//单位管理费用
  salesCostPerUnit: 'Sales cost per unit',//单位销售费用
  enterANo: 'Enter a No.',//输入数字
  pleaseEnterCompany: 'Please enter company',//请输入公司
  chickenPrice: 'Chicken Price',// 成鸡价格
  materialCategory: 'Material category',//物料类别
  mainUnitOfMeasurement: 'Main unit of measurement',//主计量单位
  pleaseEnterTheMainUnitOfMeasurement: 'Please enter the main unit of measurement',//请输入主计量单位
  pleaseInputTheApplicationAmount: 'Please input the application amount',//请输入申请金额
  pleaseSelectTheDateOfRecording: 'Please select the date of recording',//请选择记账日期
  pleaseSelectTheDateOfApplicationInitiation: 'Please select the date of application initiation',//请选择申请发起日期
  dividendRatio: 'Dividend ratio',//分红比例
  pleaseEnterThePercentageOfDividends: 'Please enter the percentage of dividends',//请输入分红比例
  pleaseEnterTheDividendPrice: 'Please enter the dividend price',//请输入分红价格
  pleaseEnterTheMarketPrice: 'Please enter the market price',//请输入市场价格
  pleaseEnterTheExcessPrice: 'Please enter the excess price',//请输入超出价格
  pleaseSelectAStocker: 'Please select a stocker',//请选择放养员
  pleaseSelectThePersonInChargeOfStocking: 'Please select the person in charge of stocking',//请选择放放养负责人
  pleaseEnterTheTotalCatchWeight: 'Please enter the total catch weight',//请输入出栏总重量
  pleaseEnterTheAmountOfDividends: 'Please enter the amount of dividends',//请输入分红金额
  fileCode: 'File Code',//档案编码
  pleaseEnterTheFileCode: 'Please enter the file code',//请输入档案编码
  fileDescription: 'File Description',//档案描述
  pleaseEnterTheFileDescription: 'Please enter the file description',//请输入档案描述
  affiliateCategory: 'Affiliate Category',//关联类别
  costItems: 'Cost items',//成本项目
  diseaseFileCode: 'Disease file code',//疾病档案编码
  pleaseEnterTheDiseaseFileCode: 'Please enter the disease file code',//请输入疾病档案编码
  diseaseCategory: 'Disease category',//疾病类别
  pleaseSelectADiseaseCategory: 'Please select a disease category',//请选择疾病类别
  diseaseFileDescription: 'Disease File Description',//疾病档案描述
  associatedDiseaseCategories: 'Associated Disease Categories',//关联疾病类别
  diseaseDescription: 'Disease description',//疾病说明
  symptomProfileCodes: 'Symptom Profile Codes',//症状档案编码
  pleaseEnterTheSymptomProfileCode: 'Please enter the symptom profile code',//请输入症状档案编码
  symptomProfileName: 'Symptom Profile Name',//症状档案名称
  pleaseEnterTheNameOfTheSymptomProfile: 'Please enter the name of the symptom profile',//请输入症状档案名称
  fileType: 'File Type',//档案类型
  symptomFileDescription: 'Symptom file description',//症状档案描述
  treatmentPlanName: 'Treatment plan name',//治疗方案名称
  pleaseEnterTheNameOfTheTreatmentPlan: 'Please enter the name of the treatment plan',//请输入治疗方案名称
  treatmentPlanDescription: 'Treatment plan description',//治疗方案描述
  organsAnatomyFileCode: 'Organs anatomy file code',//脏器解剖档案编码
  pleaseEnterTheAnatomyFileCode: 'Please enter the anatomy file code',//请输入脏器解剖档案编码
  anatomyFileName: 'Anatomy file name',//脏器解剖档案名称
  pleaseEnterTheNameOfTheOrganAutopsyFile: 'Please enter the name of the organ autopsy file',//请输入脏器解剖档案名称
  pleaseSelectValidOrNot: 'Please select valid or not',//请选择是否有效
  visceralAnatomyFileType: 'Visceral anatomy file type',//脏器解剖档案类型
  organDissectionClassification: 'Organ dissection classification',//脏器解剖分类
  descriptionOfTheOrganDissectionFile: 'Description of the organ dissection file',//脏器解剖档案描述
  inspectionSubcategoryCode: 'Inspection subcategory code',//巡检小类编码
  pleaseEnterTheInspectionSubcategoryCode: 'Please enter the inspection subcategory code',//请输入巡检小类编码
  descriptionOfInspectionSubcategory: 'Description of inspection subcategory',//巡检小类描述
  pleaseEnterTheInspectionSubcategoryDescription: 'Please enter the inspection subcategory description',//请输入巡检小类描述
  inspectionCategory: 'Inspection category',//巡检大类
  pleaseSelectTheInspectionCategory: 'Please select the inspection category',//请选择巡检大类
  inspectionSubCategoryNumber: 'Inspection sub-category number',//巡检小类编号
  nameOfInspectionCategory: 'Name of inspection category',//巡检小类名称
  recurringIndicatorFileNumber: 'Recurring indicator file number',//循环指标档案编号
  pleaseEnterTheCycleIndexFileNumber: 'Please enter the cycle index file number',//请输入循环指标档案编号
  circularIndicatorFileName: 'Circular indicator file name',//循环指标档案名称
  pleaseEnterTheNameOfTheCircularIndicatorFile: 'Please enter the name of the circular indicator file',//请输入循环指标档案名称
  breedingCategory: 'Breeding category',//饲养品类
  feedingStage: 'Feeding stage',//饲养阶段
  survivalRate: 'Survival rate',//成活率
  averageWeightOfAdultChickens: 'Average weight of poultry',//成鸡均重
  feedingAmount: 'Feeding amount',//喂料量
  realMeatRatio: 'Real meat ratio',//真实料肉比
  regularRatio: 'Regular ratio',//常规料肉比
  serviceCompanyGuaranteePoint: 'Service company guarantee point',//服务公司保本点
  seedlingPriceToMeatRatio: 'Seedling price to meat ratio',//种苗价肉比
  feedToMeatRatio: 'Feed to meat ratio',//饲料价肉比
  vaccinePriceToMeatRatio: 'Vaccine price to meat ratio',//疫苗价肉比
  healthCareMedicinePriceToMeatRatio: 'Health care medicine price to meat ratio',//保健药价肉比
  treatmentMedicinePriceToMeatRatio: 'Treatment medicine price to meat ratio',//治疗药价肉比
  priceToMeatRatioForPayingFarmers: 'Price to meat ratio for paying farmers',//支付养户成本价肉比
  fileName: 'File name',//档案名称
  pleaseEnterTheNameOfTheFile: 'Please enter the name of the file',//请输入档案名称
  standardCycleIndicatorNumber: 'Standard cycle indicator number',//标准循环指标编号
  standardCycleIndicatorName: 'Standard cycle indicator name',//标准循环指标名称
  pleaseEnterTheFileName: 'Please enter the file name',//请输入档案名称
  chickenInspectionCode: 'Chicken Inspection Code',//鸡苗检查编码
  descriptionOfChickenInspection: 'Description of chicken inspection',//鸡苗检查描述
  pleaseSelectTheCategoryOfAssociation: 'Please select the category of association',//请选择关联类别
  pleaseSelectTheTypeOfFile: 'Please select the type of file',//请选择档案类型
  symptomCategory: 'Symptom Category',//症状类别
  pleaseSelectAnExpenseItemCategory: 'Please select an expense item category',//请选择费用项类别
  pleaseEnterADiseaseFileDescription: 'Please enter a disease file description',//请输入疾病档案描述
  associatedDiseaseDescription: 'Associated disease description',//关联疾病说明
  pleaseEnterADiseaseDescription: 'Please enter a disease description',//请输入疾病说明\描述
  symptomProfile: 'Symptom Profile',//症状档案
  symptomName: 'Symptom name',//症状名称
  symptomDescription: 'Symptom Description',//症状说明
  visceralAnatomyProfile: 'Visceral anatomy profile',//脏器解剖档案
  organAnatomyName: 'Organ anatomy name',//脏器解剖名称
  organAnatomyDescription: 'Organ anatomy description',//脏器解剖说明
  treatmentPlanFile: 'Treatment plan file',//治疗方案档案
  treatmentProtocolName: 'Treatment protocol name',//治疗方案名称
  treatmentProtocolDescription: 'Treatment protocol description',//治疗方案说明
  symptomCategory: 'Symptom Category',//症状类别
  pleaseEnterTheSymptomFileCode: 'Please enter the symptom file code',//请输入症状档案编码
  pleaseEnterTheNameOfTheSymptomProfile: 'Please enter the name of the symptom profile',//请输入症状档案名称
  symptomProfileDescription: 'Symptom Profile Description',//症状档案描述
  pleaseEnterTheSymptomProfileDescription: 'Please enter the symptom profile description',//请输入症状档案描述
  treatmentPlanCode: 'Treatment Plan Code',//治疗方案编码
  pleaseEnterTheTreatmentPlanCode: 'Please enter the treatment plan code',//请输入治疗方案编码
  treatmentPlanDescription: 'Treatment plan description',//治疗方案描述
  pleaseEnterTheTreatmentProtocolDescription: 'Please enter the treatment protocol description',//请输入治疗方案描述
  organsAnatomyCategory: 'Organs Anatomy Category',//脏器解剖类别
  pleaseSelectAnatomyCategory: 'Please select anatomy category',//请选择脏器解剖类别
  descriptionOfTheOrganAutopsyFile: 'Description of the organ autopsy file',//脏器解剖档案描述
  pleaseEnterTheOrganAutopsyFileDescription: 'Please enter the organ autopsy file description',//请输入脏器解剖档案描述
  pleaseEnterTheInspectionItemDescription: 'Please enter the inspection item description',//请输入巡检项描述
  pleaseSelectTheBreedingCategory: 'Please select the breeding category',//请选择饲养品类
  pleaseEnterTheFeedingStage: 'Please enter the feeding stage',//请输入饲养阶段
  pleaseSelectRearingPeriod: 'Please select rearing period',//请选择饲养周期
  pleaseInputTheSurvivalRate: 'Please input the survival rate',//请输入成活率
  pleaseEnterTheAverageWeightOfAdultChickens: 'Please enter the average weight of poultry',//请输入成鸡均重
  pleaseEnterTheFeedingRate: 'Please enter the feeding rate',//请输入喂料量
  pleaseEnterTheRealMeatRatio: 'Please enter the real meat ratio',//请输入真实料肉比
  pleaseEnterTheRegularMeatRatio: 'Please enter the regular meat ratio',//请输入常规料肉比
  pleaseEnterTheServiceCompanyGuaranteePoint: 'Please enter the service company guarantee point',//请输入服务公司保本点
  pleaseEnterTheSeedlingPriceToMeatRatio: 'Please enter the seedling price to meat ratio',//请输入种苗价肉比
  pleaseEnterFeedPriceToMeatRatio: 'Please enter feed price to meat ratio',//请输入饲料价肉比
  pleaseEnterVaccinePriceToMeatRatio: 'Please enter vaccine price to meat ratio',//请输入疫苗价肉比
  pleaseEnterHealthDrugPriceToMeatRatio: 'Please enter health drug price to meat ratio',//请输入保健药价肉比
  pleaseEnterThePriceOfTherapeuticDrugs: 'Please enter the price of therapeutic drugs',//请输入治疗药价肉比
  pleaseEnterTheMeatRatioOfTheCostOfPayingFarmers: 'Please enter the meat ratio of the cost of paying farmers',//请输入支付养户成本价肉比
  pleaseSelectMenuType: 'please Select Menu Type', // 请选择菜单类型
  whetherInventoryManagement: 'whether inventory management',//是否库存管理
  deliveryDate: 'delivery date',//交货日期
  pleaseSelectDeliveryDate: 'please Select Delivery Date', // 请选择交货日期
  batchSource: 'Batch source',//批次来源
  pleaseSelectBatchSource: 'please Select Batch source',//请选择批次来源
  pleaseSelectEffectiveTime: 'please Select  Effective time',//请选择生效时间
  pleaseSelectContractID: 'please Select  Contract ID',//请选择合同号
  settlementUnitPrice: 'Settlement unit price',//结算单价
  pleaseSelectTheBreedingStandard: 'Please select the breeding standard',//请选择养殖标准
  docCost: 'DOC Cost',//禽苗成本
  pleaseEnterTheDocCost: 'Please enter the DOC cost',//请输入禽苗
  unitPriceType: 'Unit price type',//单价类型
  marginRecord: 'Margin record',//保证金记录
  businessItem: 'Business Item',//业务项目
  placementDate: 'Placement Date',//进鸡日期
  changeType: 'Change type',//变更类型
  pleaseSelectChangeType: 'Please select change type',//请选择变更类型
  method: 'Method',//方式
  pleaseSelectMethod: 'Please select method',//请选择方式
  drawDownContractPriceList: 'Drawdown contract price list',//提取合同价格清单
  docApplicationForm: 'DOC application form',//禽苗申请单
  pleaseSelectTheDocRequestForm: 'Please select the DOC request form',//请选择禽苗申请单
  pleaseSelectThePoultryDeliveryWarehouse: 'Please select the poultry delivery warehouse',//请选择禽发货仓库
  pleaseEnter0OrPositiveInteger: 'Please enter 0 or positive integer',//请输入0或正整数
  pleaseSelectBusinessType: 'Please select business type',//请选择业务类型
  paymentMethod: 'Payment method',//付款方式
  theCodeMustStartWithALetterAndCanContainNumbersUnderscoresHorizontalBars: 'The code must start with a letter and can contain numbers, underscores, horizontal bars',//编码必须以字母开头，可包含数字、下划线、横杠'
  extractTheListOfContractPrices: 'Extract the list of contract prices',//提取合同价格清单
  pleaseSelectThePaymentMethod: 'Please select the payment method',//请选择付款方式
  pleaseSelectTheApplicationInitiationTime: 'Please select the application initiation time',//请选择申请发起时间
  mustBe0OrAPositiveInteger: 'Must be 0 or a positive integer',//必须为0或正整数
  minimumPrice: 'Minimum price',//最低价
  lowestPriceCannotBeGreaterThanTheHighestPrice: 'Lowest price cannot be greater than the highest price',//最低价不能大于最高价
  highestPrice: 'Highest Price',//最高价
  theHighestPriceCannotBeLessThanTheLowestPrice: 'The highest price cannot be less than the lowest price',//最高价不能小于最低价
  eggStorage: 'Egg storage (feathering)',//蛋品入库(换羽)
  detailImport: 'Detail import',//明细导入
  materialConversionDetails: 'Material conversion details',//物料转换明细
  newFarm: 'New farm',//新增养殖场
  kiloBird: 'Kilo/Bird',//斤/羽
  rmbKilo: 'RMB/Kilo',//元/斤
  changeRange: 'Change range',//变更范围
  settlementDate: 'Settlement date',//结算日期
  breedingContract: 'Breeding contract',//养殖合同
  pleaseEnterTheBreedingContract: 'Please enter the breeding contract',//请输入养殖合同
  pleaseSelectTheSettlementDate: 'Please select the settlement date',//请选择结算日期
  numberOfSlaughter: 'Number of slaughter',//出栏数量
  bird: 'Bird',//羽
  deductedWeight: 'Deducted weight',//扣减重量
  deductionAmount: 'Deduction amount',//扣减金额
  pleaseEnterTheAmountToBeDeducted: 'Please enter the amount to be deducted',//请输入扣减金额
  increaseInWeight: 'Increase in weight',//增加重量
  pleaseEnterTheIncreaseWeight: 'Please enter the increase weight',//请输入增加重量
  increaseAmount: 'Increase Amount',//增加金额
  pleaseEnterTheIncreaseAmount: 'Please enter the increase amount',//请输入增加金额
  averageUnitPrice: 'Average unit price',//平均单价
  pleaseEnterTheAverageUnitPrice: 'Please enter the average unit price',//请输入平均单价
  pleaseEnterTheNumberOfSlaughters: 'Please enter the number of slaughters',//请输入出栏数量
  theNumberOfSlaughterMustBeGreaterThan0: 'The number of slaughter must be greater than 0',//出栏数量必须大于0
  pleaseEnterTheContractQuantity: 'Please enter the contract quantity',//请输入合同数量
  contractQuantityMustBeGreaterThan0: 'Contract quantity must be greater than 0',//合同数量必须大于0
  pleaseEnterTheSlaughterWeight: 'Please enter the slaughter weight',//请输入出栏重量
  slaughterWeightMustBeGreaterThan0: 'Slaughter weight must be greater than 0',//出栏重量必须大于0
  pleaseEnterTheDeductionWeight: 'Please enter the deduction weight',//请输入扣减重量
  deductedWeightMustBeGreaterThanOrEqualTo0: 'Deducted weight must be greater than or equal to 0',//扣减重量必须大于等于0
  pleaseEnterTheIncreaseWeight: 'Please enter the increase weight',//请输入增加重量
  increaseWeightMustBeGreaterThanOrEqualTo0: 'Increase weight must be greater than or equal to 0',//增加重量必须大于等于0
  unitPriceMustBeGreaterThanOrEqualTo0: 'Unit price must be greater than or equal to 0',//单价必须大于等于0
  amountMustBeGreaterThanOrEqualTo0: 'Amount must be greater than or equal to 0',//金额必须大于等于0
  pleaseEnterTheAmountToBeDeducted: 'Please enter the amount to be deducted',//请输入扣减金额
  deductionAmountMustBeGreaterThanOrEqualTo0: 'Deduction amount must be greater than or equal to 0',//扣减金额必须大于等于0
  pleaseEnterTheIncreaseAmount: 'Please enter the increase amount',//请输入增加金额
  theIncreaseAmountMustBeGreaterThanOrEqualTo0: 'The increase amount must be greater than or equal to 0',//增加金额必须大于等于0
  numberOfSlaughtered: 'Number of slaughtered',//出栏羽数
  weightOfSlaughter: 'Weight of slaughter (kg)',//出栏重量(kg)
  averagePigeonWeight: 'Average pigeon weight(kg/feather)',//平均羽重(kg/羽)
  amountOfRecovery: 'Amount of recovery',//回收金额
  numberOfDoc: 'Number of DOC',//禽苗数
  pleaseEnterTheNumberOfDoc: 'Please enter the number of DOC',//请输入禽苗数
  mortality: 'Mortality',//死淘数
  pleaseEnterTheMortaility: 'Please enter the mortaility',//请输入死淘数
  numberOfGifts: 'Number of gifts',//赠送数
  pleaseEnterTheNumberOfGifts: 'Please enter the number of gifts',//请输入赠送数
  amountOfDoc: 'Amount of DOC',//禽苗金额
  pleaseEnterTheAmountOfDoc: 'Please enter the amount of DOC',//请输入禽苗金额
  feedConsumption: 'Feed consumption',//饲料耗用量
  pleaseEnterTheAmountOfFeedConsumed: 'Please enter the amount of feed consumed',//请输入饲料耗用量
  amountOfFeed: 'Amount of feed',//饲料金额
  pleaseEnterTheAmountOfFeed: 'Please enter the amount of feed',//请输入饲料金额
  amountOfMedicineConsumption: 'Amount of medicine consumption',//药品耗用金额
  pleaseEnterTheAmountOfMedicineConsumption: 'Please enter the amount of medicine consumption',//请输入药品耗用金额
  amountOfVaccineConsumption: 'Amount of vaccine consumption',//疫苗耗用金额
  pleaseEnterTheAmountOfVaccineConsumption: 'Please enter the amount of vaccine consumption',//请输入疫苗耗用金额
  totalAmount: 'Total amount',//合计金额
  pleaseEnterTheTotalAmount: 'Please enter the total amount',//请输入合计金额
  pleaseEnterTheMortality: 'Please enter the mortality',//请输入死淘数
  amountRecovered: 'Amount recovered',//回收金额
  pleaseEnterTheAmountRecovered: 'Please enter the amount recovered',//请输入回收金额
  costAmount: 'Cost amount',//成本金额
  pleaseEnterTheCostAmount: 'Please enter the cost amount',//请输入成本金额
  subsidyAmount: 'Subsidy amount',//补贴金额
  pleaseEnterTheAmountOfSubsidy: 'Please enter the amount of subsidy',//请输入补贴金额
  otherSubsidies: 'Other subsidies',//其他补贴
  pleaseEnterOtherSubsidies: 'Please enter other subsidies',//请输入其他补贴
  costAmount: 'Cost amount',//费用金额
  pleaseEnterTheAmountOfExpenses: 'Please enter the amount of expenses',//请输入费用金额
  penaltyAmount: 'Penalty amount',//惩罚金额
  pleaseEnterTheAmountOfPenalty: 'Please enter the amount of penalty',//请输入惩罚金额
  otherPenalties: 'Other penalties',//其他惩罚
  pleaseEnterOtherPenalties: 'Please enter other penalties',//请输入其他惩罚
  basicSurrogateFee: 'Basic Surrogate Fee',//基本代养费
  marginBalance: 'Margin Balance',//保证金余额
  amountDue: 'Amount due',//应付金额
  marginWithholding: 'Margin withholding',//保证金扣缴
  actualAmountPaid: 'Actual amount paid',//实付金额
  pleaseEnterTheAmountOfDepositWithholding: 'Please enter the amount of deposit withholding',//请输入保证金扣缴金额
  settlementFormVerificationDidNotPass: 'Settlement form verification did not pass',//结算表单校验未通过
  pleaseSelectTheDate: 'Please select the date',//请选择日期
  pleaseEnterTheDailyPrice: 'Please enter the daily price',//请输入每日价格
  pleaseEnterTheNumber: 'Please enter the number',//请输入编号
  pleaseSelectTheStandardCycleIndexNumber: 'Please select the standard cycle index number',//请选择标准循环指标编号
  pleaseEnterTheOrganAnatomyCategory: 'Please enter the organ anatomy category',//请输入脏器解剖类别
  pleaseEnterTheSymptomClassification: 'Please enter the symptom classification',//请输入症状分类
  farmName: 'Farm name',//农场名称
  pleaseEnterTheNameOfTheFarm: 'Please enter the name of the farm',//请输入农场名称
  institutionType: 'Institution Type',//机构类型
  pleaseSelectTheTypeOfOrganization: 'Please select the type of organization',//请选择机构类型
  createABuilding: 'Create a building',//创建栋舍
  pleaseChooseToCreateABuilding: 'Please choose to create a building',//请选择创建栋舍
  numberOfBuildings: 'Number of buildings',//栋舍数
  pleaseEnterTheNumberOfBuildings: 'Please enter the number of buildings',//请输入栋舍数
  createWarehouse: 'Create warehouse',//创建仓库
  pleaseChooseToCreateAWarehouse: 'Please choose to create a warehouse',//请选择创建仓库
  permissionAssignment: 'Permission assignment',//权限分配
  pleaseSelectUser: 'Please select user',//请选择用户
  pleaseSelectTheDrugWarehouse: 'Please select the drug warehouse',//请选择药品仓库
  pleaseEnterTheWarehousingOrderNumber: 'Please enter the warehousing order number',//请输入入库单号
  transferOutDepartment: 'Transfer out department',//转出部门
  pleaseSelectTheTransferDepartment: 'Please select the transfer department',//请选择转出部门
  transferToDepartment: 'Transfer to department',//转入部门
  pleaseSelectTheTransferDepartment: 'Please select the transfer department',//请选择转入部门
  date: 'date',//日期
  featherKg: 'feather/kg',//羽/KG
  poultrySeedlings: 'Poultry seedlings',//禽苗
  pleaseEnterPoultrySeedlings: 'Please enter poultry seedlings',//请输入禽苗
  pleaseEnterAUsername: 'Please enter a username', // 请输入用户名!
  pleaseEnterAPassword: 'Please enter a password', // 请输入密码!
  pleaseEnterTheVerificationCode: 'Please enter the verification code', // 请输入验证码!
  pleaseDragTheSlider: 'Please drag the slider', // 请拖动滑块！
  loginFailed: 'Login Failed', // 登录失败
  pleaseUseChrome: 'Please use Google or Google kernel browser, otherwise the relevant functions will not work normally!', // 请使用谷歌或者谷歌内核浏览器，否则相关功能将不能正常使用！
  costItemCode: 'Cost Item Code', // 成本项编号
  costItemName: 'Cost Item Name', // 成本项名称
  pleaseEnterCostItemCode: 'Please enter cost item code', // 请输入成本项编号
  pleaseEntercostItemName: 'Please enter cost item name', // 请输入成本项名称
  generateVoucher: 'Generate Voucher',//生成凭证
  syncVoucher: 'Syn. Voucher',//同步凭证
  reverseVoucher: 'Reverse Voucher',//冲销凭证
  selectVoucher: 'selectVoucher',//凭证选择
  extractMaterialCost: 'Extract Material Cost',//生产成本提取
  extractOverhead: 'Extract Overhead',//制造费用提取
  extractStockVariance: 'Extract Stock Variance',//存栏变动提取
  allocateMaterialCost: 'Allocate Material Cost',//生产成本分摊
  allocateOverhead: 'Allocate Overhead',//制造费用分摊
  allocateCatchCost: 'Allocate Catch Cost',//出栏成本分摊
  tongbuyewuleixing: 'Synchronize business types', //同步业务类型
  taskName: 'task Name', //任务类名
  cronExpression: 'cron Expression', //cron表达式
  args: 'args', //参数
  pleaseChooseTaskName: 'please Choose Task Name', //任务类名
  pleaseEnterArgs: 'please Enter Args', //请输入参数
  taskStatus: 'task Status', //任务状态
  all: 'all', //全部
  start: 'start',
  stop: 'stop', //停止
  started: 'started', //已启动
  paused: 'paused', //已暂停
  executeImmediately: 'execute Immediately', //立即执行
  saveAndScheduleTasks: 'save And Schedule Tasks', //保存并安排任务
  applicableBusiness: 'applicable Business', //适用业务
  pleaseChooseApplicableBusiness: 'please Choose Applicable Business' //请选择适用业务
}